const cities = [
  { Id: 1, ChineseName: "北京", Name: "Beijing", __EMPTY_2: "" },
  { Id: 2, ChineseName: "上海", Name: "Shanghai" },
  { Id: 3, ChineseName: "天津", Name: "Tianjin", __EMPTY_2: "" },
  { Id: 4, ChineseName: "重庆", Name: "Chongqing" },
  { Id: 5, ChineseName: "哈尔滨", Name: "Harbin" },
  { Id: 6, ChineseName: "大连", Name: "Dalian" },
  { Id: 7, ChineseName: "青岛", Name: "Qingdao" },
  { Id: 10, ChineseName: "西安", Name: "Xi'an" },
  { Id: 11, ChineseName: "敦煌", Name: "Dunhuang" },
  { Id: 12, ChineseName: "南京", Name: "Nanjing" },
  { Id: 13, ChineseName: "无锡", Name: "Wuxi" },
  { Id: 14, ChineseName: "苏州", Name: "Suzhou" },
  { Id: 15, ChineseName: "扬州", Name: "Yangzhou" },
  { Id: 16, ChineseName: "镇江", Name: "Zhenjiang" },
  { Id: 17, ChineseName: "杭州", Name: "Hangzhou" },
  { Id: 19, ChineseName: "舟山", Name: "Zhoushan" },
  { Id: 22, ChineseName: "绍兴", Name: "Shaoxing" },
  { Id: 23, ChineseName: "黄山", Name: "Huangshan" },
  { Id: 24, ChineseName: "九江", Name: "Jiujiang" },
  { Id: 25, ChineseName: "厦门", Name: "Xiamen" },
  { Id: 26, ChineseName: "武夷山", Name: "Wuyishan" },
  { Id: 27, ChineseName: "张家界", Name: "Zhangjiajie" },
  { Id: 28, ChineseName: "成都", Name: "Chengdu" },
  { Id: 30, ChineseName: "深圳", Name: "Shenzhen" },
  { Id: 31, ChineseName: "珠海", Name: "Zhuhai" },
  { Id: 32, ChineseName: "广州", Name: "Guangzhou" },
  { Id: 33, ChineseName: "桂林", Name: "Guilin" },
  { Id: 34, ChineseName: "昆明", Name: "Kunming" },
  { Id: 35, ChineseName: "西双版纳", Name: "Xishuangbanna" },
  { Id: 36, ChineseName: "大理", Name: "Dali" },
  { Id: 37, ChineseName: "丽江", Name: "Lijiang" },
  { Id: 38, ChineseName: "贵阳", Name: "Guiyang" },
  { Id: 39, ChineseName: "乌鲁木齐", Name: "Wulumuqi" },
  { Id: 41, ChineseName: "拉萨", Name: "Lhasa" },
  { Id: 42, ChineseName: "海口", Name: "Haikou" },
  { Id: 43, ChineseName: "三亚", Name: "Sanya" },
  { Id: 44, ChineseName: "文昌", Name: "Wenchang" },
  { Id: 45, ChineseName: "万宁", Name: "Wanning" },
  { Id: 46, ChineseName: "五指山", Name: "Wuzhishan" },
  { Id: 47, ChineseName: "屯昌", Name: "Tunchang" },
  { Id: 48, ChineseName: "东方", Name: "Dongfang" },
  { Id: 49, ChineseName: "乐东", Name: "Ledong" },
  { Id: 50, ChineseName: "定安", Name: "Ding'an" },
  { Id: 52, ChineseName: "琼海", Name: "Qionghai" },
  { Id: 53, ChineseName: "琼中", Name: "Qiongzhong" },
  { Id: 54, ChineseName: "保亭", Name: "Baoting" },
  { Id: 55, ChineseName: "陵水", Name: "Lingshui" },
  { Id: 56, ChineseName: "昌江", Name: "Cangjiang" },
  { Id: 57, ChineseName: "儋州", Name: "Danzhou" },
  { Id: 58, ChineseName: "香港", Name: "Hong Kong" },
  { Id: 59, ChineseName: "澳门", Name: "Macau" },
  { Id: 62, ChineseName: "马六甲", Name: "Melaka" },
  { Id: 72, ChineseName: "瓜拉丁加奴", Name: "Kuala Terengganu" },
  { Id: 73, ChineseName: "新加坡", Name: "Singapore" },
  { Id: 74, ChineseName: "长白山", Name: "ChangBaiShan" },
  { Id: 82, ChineseName: "南通", Name: "Nantong" },
  { Id: 83, ChineseName: "昆山", Name: "Kunshan" },
  { Id: 84, ChineseName: "海宁", Name: "Haining" },
  { Id: 85, ChineseName: "永嘉", Name: "Yongjia" },
  { Id: 86, ChineseName: "湖州", Name: "Huzhou" },
  { Id: 90, ChineseName: "临安", Name: "Linan" },
  { Id: 91, ChineseName: "九寨沟", Name: "Jiuzhaigou" },
  { Id: 92, ChineseName: "日喀则", Name: "Rikaze" },
  { Id: 93, ChineseName: "迪庆", Name: "Diqing" },
  { Id: 94, ChineseName: "都江堰", Name: "Dujiangyan" },
  { Id: 95, ChineseName: "峨眉山", Name: "Emeishan" },
  { Id: 96, ChineseName: "常熟", Name: "Changshu" },
  { Id: 97, ChineseName: "阿里", Name: "Ali" },
  { Id: 98, ChineseName: "伊犁", Name: "Yili" },
  { Id: 99, ChineseName: "银川", Name: "Yinchuan" },
  { Id: 100, ChineseName: "兰州", Name: "Lanzhou" },
  { Id: 103, ChineseName: "呼和浩特", Name: "Huhehaote" },
  { Id: 104, ChineseName: "平遥", Name: "Pingyao" },
  { Id: 105, ChineseName: "太原", Name: "Taiyuan" },
  { Id: 108, ChineseName: "林芝", Name: "Nyingchi" },
  { Id: 109, ChineseName: "喀什市", Name: "Kashi" },
  { Id: 110, ChineseName: "延安", Name: "Yan'an" },
  { Id: 111, ChineseName: "咸阳", Name: "Xianyang" },
  { Id: 112, ChineseName: "宝鸡", Name: "Baoji" },
  { Id: 118, ChineseName: "铜川", Name: "Tongchuan" },
  { Id: 119, ChineseName: "华阴", Name: "Huayin" },
  { Id: 124, ChineseName: "西宁", Name: "Xining" },
  { Id: 129, ChineseName: "汉中", Name: "Hanzhong" },
  { Id: 132, ChineseName: "格尔木", Name: "Golmud" },
  { Id: 134, ChineseName: "灵石", Name: "Lingshi" },
  { Id: 135, ChineseName: "介休", Name: "Jiexiu" },
  { Id: 136, ChineseName: "大同", Name: "Datong" },
  { Id: 137, ChineseName: "长治", Name: "Changzhi" },
  { Id: 139, ChineseName: "临汾", Name: "Linfen" },
  { Id: 140, ChineseName: "运城", Name: "Yuncheng" },
  { Id: 141, ChineseName: "包头", Name: "Baotou" },
  { Id: 142, ChineseName: "海拉尔", Name: "Hailar" },
  { Id: 143, ChineseName: "曲阜", Name: "Qufu" },
  { Id: 144, ChineseName: "济南", Name: "Jinan" },
  { Id: 147, ChineseName: "秦皇岛", Name: "Qinhuangdao" },
  { Id: 149, ChineseName: "齐齐哈尔", Name: "Qiqihar" },
  { Id: 150, ChineseName: "牡丹江", Name: "Mudanjiang" },
  { Id: 155, ChineseName: "漠河", Name: "Mohe" },
  { Id: 157, ChineseName: "鸡西", Name: "Jixi" },
  { Id: 158, ChineseName: "长春", Name: "Changchun" },
  { Id: 159, ChineseName: "吉林", Name: "Jilin" },
  { Id: 166, ChineseName: "克拉玛依", Name: "Karamay" },
  { Id: 168, ChineseName: "新西伯利亚", Name: "Novosibirsk" },
  { Id: 171, ChineseName: "安康", Name: "Ankang" },
  { Id: 173, ChineseName: "阿克苏", Name: "Aksu" },
  { Id: 174, ChineseName: "阿拉木图", Name: "Almaty" },
  { Id: 175, ChineseName: "阿勒泰", Name: "Aletai" },
  {
    Id: 176,
    ChineseName: "阿姆斯特丹",
    Name: "Amsterdam",
    country: "Netherlands",
  },
  {
    Id: 176,
    ChineseName: "阿姆斯特丹",
    Name: "Amstelveen",
    country: "Netherlands",
  },
  { Id: 177, ChineseName: "安庆", Name: "Anqing" },
  { Id: 178, ChineseName: "鞍山", Name: "Anshan" },
  { Id: 179, ChineseName: "安顺", Name: "Anshun" },
  { Id: 181, ChineseName: "安阳", Name: "Anyang" },
  { Id: 182, ChineseName: "蚌埠", Name: "Bengbu" },
  { Id: 185, ChineseName: "保定", Name: "Baoding" },
  { Id: 186, ChineseName: "玉溪", Name: "Yuxi" },
  { Id: 189, ChineseName: "北海", Name: "Beihai" },
  { Id: 192, ChineseName: "巴黎", Name: "Paris" },
  { Id: 193, ChineseName: "柏林", Name: "Berlin" },
  { Id: 196, ChineseName: "布鲁塞尔", Name: "Brussels" },
  { Id: 197, ChineseName: "保山", Name: "Baoshan" },
  { Id: 199, ChineseName: "白山", Name: "White Mountain" },
  { Id: 201, ChineseName: "常德", Name: "Changde" },
  { Id: 202, ChineseName: "赤峰", Name: "Chifeng" },
  { Id: 205, ChineseName: "长崎", Name: "Nagasaki" },
  { Id: 206, ChineseName: "长沙", Name: "Changsha" },
  { Id: 207, ChineseName: "冲绳", Name: "Okinawa" },
  { Id: 208, ChineseName: "嵊泗", Name: "Shengsi" },
  { Id: 209, ChineseName: "广德", Name: "Guangde" },
  { Id: 211, ChineseName: "朝阳", Name: "Chaoyang" },
  { Id: 213, ChineseName: "常州", Name: "Changzhou" },
  { Id: 214, ChineseName: "滁州", Name: "Chuzhou" },
  { Id: 215, ChineseName: "潮州", Name: "Chaozhou" },
  { Id: 216, ChineseName: "沧州", Name: "Cangzhou" },
  { Id: 218, ChineseName: "池州", Name: "Chizhou" },
  { Id: 219, ChineseName: "大阪", Name: "Osaka" },
  { Id: 220, ChineseName: "迪拜", Name: "Dubai" },
  { Id: 221, ChineseName: "丹东", Name: "Dandong" },
  { Id: 222, ChineseName: "登封", Name: "Dengfeng" },
  { Id: 223, ChineseName: "东莞", Name: "Dongguan" },
  { Id: 228, ChineseName: "东京", Name: "Tokyo" },
  { Id: 231, ChineseName: "大庆", Name: "Daqing" },
  { Id: 233, ChineseName: "底特律", Name: "Detroit" },
  { Id: 236, ChineseName: "东营", Name: "Dongying" },
  { Id: 237, ChineseName: "德阳", Name: "Deyang" },
  { Id: 238, ChineseName: "丹阳", Name: "Danyang" },
  { Id: 245, ChineseName: "恩施", Name: "Enshi" },
  { Id: 246, ChineseName: "福鼎", Name: "Fuding" },
  { Id: 248, ChineseName: "福冈", Name: "Fukuoka" },
  { Id: 250, ChineseName: "法兰克福", Name: "Frankfurt" },
  { Id: 251, ChineseName: "佛山", Name: "Foshan" },
  { Id: 252, ChineseName: "抚顺", Name: "Fushun" },
  { Id: 253, ChineseName: "釜山", Name: "Busan" },
  { Id: 254, ChineseName: "阜新", Name: "Fuxin" },
  { Id: 255, ChineseName: "富蕴", Name: "Fuyun" },
  { Id: 257, ChineseName: "阜阳", Name: "Fuyang" },
  { Id: 258, ChineseName: "福州", Name: "Fuzhou" },
  { Id: 260, ChineseName: "哥本哈根", Name: "Copenhagen" },
  { Id: 262, ChineseName: "广岛", Name: "Hiroshima" },
  { Id: 263, ChineseName: "冈山", Name: "Okayama" },
  { Id: 267, ChineseName: "广元", Name: "Guangyuan" },
  { Id: 268, ChineseName: "赣州", Name: "Ganzhou" },
  { Id: 271, ChineseName: "横滨", Name: "Yokohama" },
  { Id: 272, ChineseName: "淮北", Name: "Huaibei" },
  { Id: 273, ChineseName: "哈巴罗夫斯克", Name: "Khabarovsk" },
  { Id: 274, ChineseName: "首尔", Name: "Seoul" },
  { Id: 275, ChineseName: "邯郸", Name: "Handan" },
  { Id: 277, ChineseName: "赫尔辛基", Name: "Helsinki" },
  { Id: 278, ChineseName: "合肥", Name: "Hefei" },
  { Id: 281, ChineseName: "黑河", Name: "Heihe" },
  { Id: 282, ChineseName: "怀化", Name: "Huaihua" },
  { Id: 285, ChineseName: "哈密市", Name: "Hami" },
  { Id: 286, ChineseName: "河内", Name: "Hanoi" },
  { Id: 287, ChineseName: "淮南", Name: "Huainan" },
  { Id: 290, ChineseName: "衡水", Name: "Hengshui" },
  { Id: 292, ChineseName: "黄石", Name: "Huangshi" },
  { Id: 293, ChineseName: "华沙", Name: "Warsaw" },
  { Id: 297, ChineseName: "衡阳", Name: "Hengyang" },
  { Id: 299, ChineseName: "惠州", Name: "Huizhou" },
  { Id: 301, ChineseName: "胡志明市", Name: "Ho Chi Minh City" },
  { Id: 303, ChineseName: "金边", Name: "Phnom Penh" },
  { Id: 304, ChineseName: "加德满都", Name: "Kathmandu" },
  { Id: 305, ChineseName: "景德镇", Name: "Jingdezhen" },
  { Id: 306, ChineseName: "基辅", Name: "Kiev" },
  { Id: 307, ChineseName: "井冈山", Name: "Jinggangshan" },
  { Id: 308, ChineseName: "金华", Name: "Jinhua" },
  { Id: 310, ChineseName: "蓬莱", Name: "Penglai" },
  { Id: 313, ChineseName: "旧金山", Name: "San Francisco" },
  { Id: 315, ChineseName: "吉隆坡", Name: "Kuala Lumpur" },
  { Id: 316, ChineseName: "江门", Name: "Jiangmen" },
  { Id: 317, ChineseName: "佳木斯", Name: "Jiamusi" },
  { Id: 318, ChineseName: "济宁", Name: "Jining" },
  { Id: 321, ChineseName: "固原", Name: "Guyuan" },
  { Id: 325, ChineseName: "江阴", Name: "Jiangyin" },
  { Id: 326, ChineseName: "嘉峪关", Name: "Jiayuguan" },
  { Id: 327, ChineseName: "锦州", Name: "Jinzhou" },
  { Id: 328, ChineseName: "荆州", Name: "Jingzhou" },
  { Id: 329, ChineseName: "库车", Name: "Kuqa" },
  { Id: 330, ChineseName: "库尔勒", Name: "Korla" },
  { Id: 331, ChineseName: "开封", Name: "Kaifeng" },
  { Id: 332, ChineseName: "开罗", Name: "Cairo" },
  { Id: 333, ChineseName: "凯里", Name: "Kaili" },
  {
    Id: 334,
    ChineseName: "卡拉奇",
    Name: "Karachi",
    country: "Pakistan",
  },
  { Id: 335, ChineseName: "开平", Name: "Kaiping" },
  { Id: 336, ChineseName: "科威特", Name: "Kuwait" },
  {
    Id: 338,
    ChineseName: "伦敦",
    Name: "London",
    country: "United Kingdom",
  },
  { Id: 340, ChineseName: "廊坊", Name: "Langfang" },
  { Id: 341, ChineseName: "龙海", Name: "Longhai" },
  { Id: 343, ChineseName: "罗马", Name: "Rome" },
  { Id: 344, ChineseName: "庐山", Name: "Lushan" },
  { Id: 345, ChineseName: "乐山", Name: "Leshan" },
  { Id: 346, ChineseName: "丽水", Name: "Lishui" },
  { Id: 347, ChineseName: "洛杉矶", Name: "Los Angeles" },
  { Id: 348, ChineseName: "龙岩", Name: "Longyan" },
  { Id: 350, ChineseName: "洛阳", Name: "Luoyang" },
  { Id: 351, ChineseName: "辽阳", Name: "Liaoyang" },
  { Id: 352, ChineseName: "辽源", Name: "Liaoyuan" },
  { Id: 353, ChineseName: "连云港", Name: "Lianyungang" },
  { Id: 354, ChineseName: "柳州", Name: "Liuzhou" },
  { Id: 355, ChineseName: "泸州", Name: "Luzhou" },
  { Id: 357, ChineseName: "马德里", Name: "Madrid" },
  { Id: 358, ChineseName: "墨尔本", Name: "Melbourne" },
  { Id: 359, ChineseName: "曼谷", Name: "Bangkok" },
  { Id: 360, ChineseName: "名古屋", Name: "Nagoya" },
  { Id: 361, ChineseName: "米兰", Name: "Milan" },
  { Id: 363, ChineseName: "慕尼黑", Name: "Munich" },
  { Id: 364, ChineseName: "马尼拉", Name: "Manila" },
  { Id: 365, ChineseName: "德宏", Name: "Dehong" },
  { Id: 366, ChineseName: "莫斯科", Name: "Moscow" },
  { Id: 370, ChineseName: "绵阳", Name: "Mianyang" },
  { Id: 375, ChineseName: "宁波", Name: "Ningbo" },
  { Id: 376, ChineseName: "南昌", Name: "Nanchang" },
  { Id: 377, ChineseName: "南充", Name: "Nanchong" },
  { Id: 378, ChineseName: "宁德", Name: "Ningde" },
  { Id: 380, ChineseName: "南宁", Name: "Nanning" },
  { Id: 385, ChineseName: "南阳", Name: "Nanyang" },
  { Id: 387, ChineseName: "盘锦", Name: "Panjin" },
  { Id: 388, ChineseName: "平凉", Name: "Pingliang" },
  { Id: 399, ChineseName: "且末", Name: "Qiemo" },
  { Id: 404, ChineseName: "庆阳", Name: "Qingyang" },
  { Id: 406, ChineseName: "泉州", Name: "Quanzhou" },
  { Id: 407, ChineseName: "衢州", Name: "Quzhou" },
  { Id: 408, ChineseName: "瑞安", Name: "Ruian" },
  { Id: 411, ChineseName: "上饶", Name: "Shangrao" },
  { Id: 412, ChineseName: "瑞丽", Name: "Ruili" },
  { Id: 415, ChineseName: "圣保罗", Name: "Sao Paulo" },
  { Id: 420, ChineseName: "斯德哥尔摩", Name: "Stockholm" },
  { Id: 421, ChineseName: "绥芬河", Name: "Suifenhe" },
  { Id: 422, ChineseName: "韶关", Name: "Shaoguan" },
  { Id: 423, ChineseName: "神户", Name: "Kobe" },
  { Id: 426, ChineseName: "石河子", Name: "Shihezi" },
  { Id: 428, ChineseName: "石家庄", Name: "Shijiazhuang" },
  { Id: 434, ChineseName: "苏黎世", Name: "Zurich" },
  { Id: 436, ChineseName: "三门峡", Name: "Sanmenxia" },
  { Id: 437, ChineseName: "三明", Name: "Sanming" },
  { Id: 439, ChineseName: "山南", Name: "Shannan" },
  { Id: 440, ChineseName: "四平", Name: "Siping" },
  { Id: 441, ChineseName: "商丘", Name: "Shangqiu" },
  { Id: 444, ChineseName: "石狮", Name: "Shishi" },
  { Id: 446, ChineseName: "韶山", Name: "Shaoshan" },
  { Id: 447, ChineseName: "汕头", Name: "Shantou" },
  { Id: 448, ChineseName: "邵武", Name: "Shaowu" },
  { Id: 451, ChineseName: "沈阳", Name: "Shenyang" },
  { Id: 452, ChineseName: "十堰", Name: "Shiyan" },
  { Id: 454, ChineseName: "泰安", Name: "Taian" },
  { Id: 455, ChineseName: "塔城", Name: "Tacheng" },
  { Id: 456, ChineseName: "通化", Name: "Tonghua" },
  { Id: 458, ChineseName: "通辽", Name: "Tongliao" },
  { Id: 459, ChineseName: "铜陵", Name: "Tongling" },
  { Id: 460, ChineseName: "桐庐", Name: "Tonglu" },
  { Id: 461, ChineseName: "多伦多", Name: "Toronto" },
  { Id: 462, ChineseName: "特拉维夫", Name: "Tel Aviv Yafo" },
  { Id: 464, ChineseName: "天水", Name: "Tianshui" },
  { Id: 468, ChineseName: "唐山", Name: "Tangshan" },
  { Id: 470, ChineseName: "天台", Name: "Tiantai" },
  { Id: 473, ChineseName: "五大连池", Name: "Wudalianchi" },
  { Id: 474, ChineseName: "武当山", Name: "Wudangshan" },
  { Id: 475, ChineseName: "潍坊", Name: "Weifang" },
  { Id: 476, ChineseName: "温哥华", Name: "Vancouver" },
  { Id: 477, ChineseName: "武汉", Name: "Wuhan" },
  { Id: 478, ChineseName: "芜湖", Name: "Wuhu" },
  { Id: 479, ChineseName: "威海", Name: "Weihai" },
  { Id: 483, ChineseName: "乌兰巴托", Name: "Ulaanbaatar" },
  { Id: 484, ChineseName: "乌兰浩特", Name: "Ulanhot" },
  { Id: 485, ChineseName: "永安", Name: "Yong'an" },
  { Id: 486, ChineseName: "万象", Name: "Vientiane" },
  { Id: 489, ChineseName: "婺源", Name: "Wuyuan" },
  { Id: 491, ChineseName: "温州", Name: "Wenzhou" },
  { Id: 492, ChineseName: "梧州", Name: "Wuzhou" },
  { Id: 494, ChineseName: "西昌", Name: "Xichang" },
  { Id: 496, ChineseName: "襄阳", Name: "Xiangyang" },
  { Id: 497, ChineseName: "夏河", Name: "Xiahe" },
  { Id: 500, ChineseName: "锡林浩特", Name: "Xilinhot" },
  { Id: 501, ChineseName: "悉尼", Name: "Sydney" },
  { Id: 507, ChineseName: "新乡", Name: "Xinxiang" },
  { Id: 510, ChineseName: "信阳", Name: "Xinyang" },
  { Id: 511, ChineseName: "西雅图", Name: "Seattle" },
  { Id: 512, ChineseName: "徐州", Name: "Xuzhou" },
  { Id: 513, ChineseName: "忻州", Name: "Xinzhou" },
  { Id: 514, ChineseName: "宜宾", Name: "Yibin" },
  { Id: 515, ChineseName: "宜昌", Name: "Yichang" },
  { Id: 516, ChineseName: "永川", Name: "Yongchuan" },
  { Id: 517, ChineseName: "伊春", Name: "Yichun" },
  { Id: 518, ChineseName: "宜春", Name: "Yichun" },
  { Id: 521, ChineseName: "宿州", Name: "Suzhou" },
  { Id: 522, ChineseName: "仰光", Name: "Yangon" },
  { Id: 523, ChineseName: "延吉", Name: "Yanji" },
  { Id: 524, ChineseName: "雅加达", Name: "Jakarta" },
  { Id: 527, ChineseName: "榆林", Name: "Yulin" },
  { Id: 529, ChineseName: "伊宁市", Name: "Yining" },
  { Id: 531, ChineseName: "伊斯兰堡", Name: "Islamabad" },
  { Id: 532, ChineseName: "伊斯坦布尔", Name: "Istanbul" },
  { Id: 533, ChineseName: "烟台", Name: "Yantai" },
  { Id: 534, ChineseName: "鹰潭", Name: "Yingtan" },
  { Id: 536, ChineseName: "义乌", Name: "Yiwu" },
  { Id: 537, ChineseName: "宜兴", Name: "Yixing" },
  { Id: 539, ChineseName: "岳阳", Name: "Yueyang" },
  { Id: 540, ChineseName: "余姚", Name: "Yuyao" },
  { Id: 542, ChineseName: "淄博", Name: "Zibo" },
  { Id: 544, ChineseName: "自贡", Name: "Zigong" },
  { Id: 545, ChineseName: "遵化", Name: "Zunhua" },
  { Id: 547, ChineseName: "湛江", Name: "Zhanjiang" },
  { Id: 548, ChineseName: "诸暨", Name: "Zhuji" },
  { Id: 549, ChineseName: "芝加哥", Name: "Chicago" },
  { Id: 550, ChineseName: "张家口", Name: "Zhangjiakou" },
  { Id: 551, ChineseName: "驻马店", Name: "Zhumadian" },
  { Id: 552, ChineseName: "肇庆", Name: "Zhaoqing" },
  { Id: 553, ChineseName: "中山", Name: "Zhongshan" },
  { Id: 555, ChineseName: "昭通", Name: "Zhaotong" },
  { Id: 556, ChineseName: "中卫", Name: "Zhongwei" },
  { Id: 558, ChineseName: "遵义", Name: "Zunyi" },
  { Id: 559, ChineseName: "郑州", Name: "Zhengzhou" },
  { Id: 560, ChineseName: "漳州", Name: "Zhangzhou" },
  { Id: 562, ChineseName: "承德", Name: "Chengde" },
  { Id: 569, ChineseName: "临沂", Name: "Linyi" },
  { Id: 570, ChineseName: "富山", Name: "Toyama" },
  { Id: 571, ChineseName: "嘉兴", Name: "Jiaxing" },
  { Id: 575, ChineseName: "昌都", Name: "Qamdo" },
  { Id: 577, ChineseName: "淮安", Name: "Huai'an" },
  { Id: 578, ChineseName: "台州", Name: "Taizhou" },
  { Id: 579, ChineseName: "泰州", Name: "Taizhou" },
  { Id: 580, ChineseName: "桐乡", Name: "Tongxiang" },
  { Id: 582, ChineseName: "海盐", Name: "Haiyan" },
  { Id: 585, ChineseName: "仙台", Name: "Sendai" },
  { Id: 589, ChineseName: "巢湖", Name: "Chaohu" },
  { Id: 596, ChineseName: "嘉善", Name: "Jiashan" },
  { Id: 597, ChineseName: "兰溪", Name: "Lanxi" },
  { Id: 598, ChineseName: "湘潭", Name: "Xiangtan" },
  { Id: 601, ChineseName: "株洲", Name: "Zhuzhou" },
  { Id: 603, ChineseName: "新余", Name: "Xinyu" },
  { Id: 605, ChineseName: "六盘水", Name: "Liupanshui" },
  { Id: 606, ChineseName: "南平", Name: "Nanping" },
  { Id: 612, ChineseName: "郴州", Name: "Chenzhou" },
  { Id: 614, ChineseName: "枣庄", Name: "Zaozhuang" },
  { Id: 617, ChineseName: "台北", Name: "Taipei" },
  { Id: 619, ChineseName: "温岭", Name: "Wenling" },
  { Id: 621, ChineseName: "张家港", Name: "Zhangjiagang" },
  { Id: 622, ChineseName: "芭堤雅", Name: "Pattaya" },
  { Id: 623, ChineseName: "清迈", Name: "Chiang Mai" },
  { Id: 628, ChineseName: "海参崴", Name: "Vladivostok" },
  { Id: 631, ChineseName: "德黑兰", Name: "Tehran" },
  { Id: 633, ChineseName: "纽约", Name: "New York" },
  { Id: 635, ChineseName: "亚的斯亚贝巴", Name: "Addis ababa" },
  { Id: 637, ChineseName: "布达佩斯", Name: "Budapest" },
  { Id: 639, ChineseName: "塔什干", Name: "Tashkent" },
  { Id: 641, ChineseName: "札幌", Name: "Sapporo" },
  { Id: 642, ChineseName: "比什凯克", Name: "Bishkek" },
  { Id: 647, ChineseName: "清莱", Name: "Chiang Rai" },
  { Id: 650, ChineseName: "巴库", Name: "Baku" },
  { Id: 651, ChineseName: "维也纳", Name: "Vienna" },
  { Id: 652, ChineseName: "缙云", Name: "Jinyun" },
  { Id: 654, ChineseName: "太仓", Name: "Taicang" },
  { Id: 657, ChineseName: "神农架", Name: "Shennongjia" },
  { Id: 658, ChineseName: "建德", Name: "Jiande" },
  { Id: 659, ChineseName: "安吉", Name: "Anji" },
  { Id: 660, ChineseName: "香格里拉", Name: "Shangri-La" },
  { Id: 662, ChineseName: "酒泉", Name: "Jiuquan" },
  { Id: 663, ChineseName: "张掖", Name: "Zhangye" },
  { Id: 664, ChineseName: "武威", Name: "Wuwei" },
  { Id: 665, ChineseName: "卢森堡", Name: "Luxembourg" },
  { Id: 666, ChineseName: "日内瓦", Name: "Geneva" },
  { Id: 667, ChineseName: "莆田", Name: "Putian" },
  { Id: 670, ChineseName: "赤塔", Name: "Chita" },
  { Id: 672, ChineseName: "伊尔库茨克", Name: "Irkutsk" },
  { Id: 673, ChineseName: "萨马拉", Name: "Samara" },
  { Id: 674, ChineseName: "布加勒斯特", Name: "Bucharest" },
  { Id: 678, ChineseName: "奥克兰", Name: "Auckland" },
  { Id: 679, ChineseName: "堪培拉", Name: "Canberra" },
  { Id: 680, ChineseName: "布里斯班", Name: "Brisbane" },
  { Id: 681, ChineseName: "珀斯", Name: "Perth" },
  { Id: 682, ChineseName: "达尔文", Name: "Darwin" },
  { Id: 683, ChineseName: "开普敦", Name: "Cape Town" },
  { Id: 684, ChineseName: "约翰内斯堡", Name: "Johannesburg" },
  { Id: 687, ChineseName: "佛罗伦萨", Name: "Florence" },
  { Id: 688, ChineseName: "威尼斯", Name: "Venice" },
  { Id: 690, ChineseName: "哈瓦那", Name: "Havana" },
  { Id: 691, ChineseName: "墨西哥城", Name: "Mexico City" },
  { Id: 692, ChineseName: "阳江", Name: "Yangjiang" },
  { Id: 693, ChineseName: "河源", Name: "Heyuan" },
  { Id: 696, ChineseName: "盱眙", Name: "Xuyi" },
  { Id: 697, ChineseName: "启东", Name: "Qidong" },
  { Id: 698, ChineseName: "圣迭戈", Name: "San Diego" },
  { Id: 700, ChineseName: "盐湖城", Name: "Salt Lake City" },
  { Id: 705, ChineseName: "达拉斯", Name: "Dallas" },
  { Id: 706, ChineseName: "爱丁堡", Name: "Edinburgh" },
  { Id: 709, ChineseName: "科隆", Name: "Cologne" },
  { Id: 710, ChineseName: "雅典", Name: "Athens" },
  { Id: 712, ChineseName: "马赛", Name: "Marseille" },
  { Id: 713, ChineseName: "里昂", Name: "Lyon" },
  { Id: 717, ChineseName: "格拉纳达", Name: "Granada" },
  { Id: 718, ChineseName: "鹿特丹", Name: "Rotterdam", country: "Netherlands" },
  { Id: 720, ChineseName: "高雄", Name: "Kaohsiung" },
  { Id: 722, ChineseName: "曼彻斯特", Name: "Manchester" },
  { Id: 723, ChineseName: "巴厘岛", Name: "Bali" },
  { Id: 724, ChineseName: "孟买", Name: "Mumbai" },
  { Id: 725, ChineseName: "普吉岛", Name: "Phuket" },
  { Id: 728, ChineseName: "凯恩斯", Name: "Cairns" },
  { Id: 729, ChineseName: "台山", Name: "taishan" },
  { Id: 730, ChineseName: "卢克索", Name: "Luxor" },
  { Id: 731, ChineseName: "阿斯旺", Name: "Aswan" },
  { Id: 732, ChineseName: "乐清", Name: "Yueqing" },
  { Id: 733, ChineseName: "达卡", Name: "Dhaka" },
  { Id: 734, ChineseName: "京都", Name: "Kyoto" },
  { Id: 737, ChineseName: "济州岛", Name: "Jeju" },
  { Id: 738, ChineseName: "光州", Name: "Gwangju" },
  { Id: 739, ChineseName: "萨尔茨堡", Name: "Salzburg" },
  { Id: 740, ChineseName: "万隆", Name: "Bandung" },
  { Id: 741, ChineseName: "日惹", Name: "Yogyakarta" },
  { Id: 742, ChineseName: "沙迦", Name: "Sharjah" },
  { Id: 750, ChineseName: "广汉", Name: "Guanghan" },
  { Id: 752, ChineseName: "安克雷奇", Name: "Anchorage" },
  { Id: 753, ChineseName: "关岛", Name: "Guam" },
  { Id: 754, ChineseName: "艾哈迈达巴德", Name: "Ahmedabad" },
  { Id: 755, ChineseName: "东阳", Name: "Dongyang" },
  { Id: 756, ChineseName: "加尔各答", Name: "Kolkata" },
  { Id: 757, ChineseName: "夏威夷·火奴鲁鲁", Name: "Honolulu" },
  { Id: 759, ChineseName: "蒙特利尔", Name: "Montreal" },
  { Id: 760, ChineseName: "渥太华", Name: "Ottawa" },
  { Id: 761, ChineseName: "卡尔加里", Name: "Calgary" },
  { Id: 762, ChineseName: "杜塞尔多夫", Name: "Dusseldorf" },
  { Id: 763, ChineseName: "汉堡", Name: "Hamburg" },
  { Id: 765, ChineseName: "斯图加特", Name: "Stuttgart" },
  { Id: 766, ChineseName: "阿布扎比", Name: "Abu Dhabi" },
  { Id: 769, ChineseName: "里约热内卢", Name: "RIO DE JANEIRO" },
  { Id: 770, ChineseName: "蒙得维的亚", Name: "Montevideo" },
  { Id: 771, ChineseName: "匹兹堡", Name: "Pittsburgh" },
  { Id: 772, ChineseName: "毕尔巴鄂", Name: "Bilbao" },
  { Id: 775, ChineseName: "尼斯", Name: "Nice" },
  { Id: 776, ChineseName: "波尔多", Name: "Bordeaux" },
  { Id: 777, ChineseName: "贝尔法斯特", Name: "Belfast" },
  { Id: 780, ChineseName: "格拉斯哥", Name: "Glasgow" },
  { Id: 783, ChineseName: "拉各斯", Name: "Lagos" },
  { Id: 785, ChineseName: "毛里求斯", Name: "Mauritius" },
  { Id: 786, ChineseName: "维尔纽斯", Name: "Vilnius" },
  { Id: 787, ChineseName: "斯塔万格", Name: "Stavanger" },
  { Id: 788, ChineseName: "提华纳", Name: "Tijuana" },
  { Id: 789, ChineseName: "利雅得", Name: "Riyadh" },
  { Id: 791, ChineseName: "楠迪", Name: "Nadi" },
  { Id: 792, ChineseName: "索非亚", Name: "Sofia" },
  { Id: 794, ChineseName: "金斯敦", Name: "Kingston" },
  { Id: 795, ChineseName: "克拉根福特", Name: "Klagenfurt" },
  { Id: 798, ChineseName: "圣彼得堡", Name: "Saint Petersburg" },
  { Id: 799, ChineseName: "拉合尔", Name: "Lahore" },
  { Id: 800, ChineseName: "函馆", Name: "Hakodate" },
  { Id: 801, ChineseName: "吉达", Name: "Jeddah" },
  { Id: 803, ChineseName: "都柏林", Name: "Dublin" },
  { Id: 804, ChineseName: "哥德堡", Name: "Gothenburg" },
  { Id: 805, ChineseName: "格拉茨", Name: "Graz" },
  { Id: 806, ChineseName: "巴塞尔", Name: "basel" },
  { Id: 807, ChineseName: "布宜诺斯艾利斯", Name: "Buenos Aires" },
  { Id: 809, ChineseName: "卡萨布兰卡", Name: "Casablanca" },
  { Id: 810, ChineseName: "科伦坡", Name: "Colombo" },
  { Id: 811, ChineseName: "加拉加斯", Name: "Caracas" },
  { Id: 812, ChineseName: "坎昆", Name: "Cancun" },
  { Id: 813, ChineseName: "库斯科", Name: "Cusco" },
  { Id: 814, ChineseName: "达累斯萨拉姆", Name: "Dar es salaam" },
  { Id: 815, ChineseName: "林茨", Name: "Linz" },
  { Id: 818, ChineseName: "蒙巴萨", Name: "Mombasa" },
  { Id: 819, ChineseName: "亚松森", Name: "Asuncion" },
  { Id: 821, ChineseName: "卑尔根", Name: "Bergen" },
  { Id: 824, ChineseName: "波哥大", Name: "Bogota" },
  { Id: 825, ChineseName: "内罗毕", Name: "Nairobi" },
  { Id: 826, ChineseName: "波尔图", Name: "Porto" },
  { Id: 827, ChineseName: "奥斯陆", Name: "Oslo" },
  {
    Id: 829,
    ChineseName: "白沙瓦",
    Name: "Peshawar",
    country: "Pakistan",
  },
  { Id: 830, ChineseName: "巴拿马城", Name: "Panama City" },
  { Id: 831, ChineseName: "雷克雅未克", Name: "Reykjavik" },
  { Id: 832, ChineseName: "科克", Name: "Cork" },
  { Id: 833, ChineseName: "荣成", Name: "Rongcheng" },
  { Id: 834, ChineseName: "伯尔尼", Name: "Berne" },
  { Id: 835, ChineseName: "贝鲁特", Name: "Beirut" },
  { Id: 837, ChineseName: "利马", Name: "Lima" },
  { Id: 838, ChineseName: "布里斯托尔", Name: "Bristol" },
  { Id: 840, ChineseName: "法鲁", Name: "Faro" },
  { Id: 843, ChineseName: "惠灵顿", Name: "Wellington" },
  { Id: 849, ChineseName: "哈拉雷", Name: "Harare" },
  { Id: 852, ChineseName: "圣地亚哥", Name: "Santiago" },
  { Id: 853, ChineseName: "马斯喀特", Name: "Muscat" },
  { Id: 854, ChineseName: "明斯克", Name: "Minsk" },
  { Id: 856, ChineseName: "达喀尔", Name: "Dakar" },
  { Id: 858, ChineseName: "基多", Name: "Quito" },
  { Id: 859, ChineseName: "泊特莫尔斯比港", Name: "Port Moresby" },
  { Id: 862, ChineseName: "温德和克", Name: "Windhoek" },
  { Id: 866, ChineseName: "凤凰", Name: "Fenghuang" },
  { Id: 867, ChineseName: "延边朝鲜族自治州", Name: "Yanbian" },
  { Id: 868, ChineseName: "仙居", Name: "Xianju" },
  { Id: 871, ChineseName: "阳朔", Name: "Yangshuo" },
  { Id: 872, ChineseName: "新昌", Name: "Xinchang" },
  { Id: 895, ChineseName: "新沂", Name: "Xinyi" },
  { Id: 901, ChineseName: "鄯善", Name: "Shanshan" },
  { Id: 907, ChineseName: "阳泉", Name: "Yangquan" },
  { Id: 918, ChineseName: "娄底", Name: "Loudi" },
  { Id: 929, ChineseName: "浦江", Name: "Pujiang" },
  { Id: 933, ChineseName: "吉安", Name: "Jian" },
  { Id: 937, ChineseName: "咸宁", Name: "Xianning" },
  { Id: 940, ChineseName: "耒阳", Name: "Leiyang" },
  { Id: 944, ChineseName: "桐城", Name: "Tongcheng" },
  { Id: 947, ChineseName: "邢台", Name: "Xingtai" },
  { Id: 951, ChineseName: "鹤壁", Name: "Hebi" },
  { Id: 954, ChineseName: "兴宁", Name: "Xingning" },
  { Id: 956, ChineseName: "揭阳", Name: "Jieyang" },
  { Id: 959, ChineseName: "武义", Name: "Wuyi" },
  { Id: 960, ChineseName: "永康", Name: "Yongkang" },
  { Id: 963, ChineseName: "海城", Name: "Haicheng" },
  { Id: 967, ChineseName: "大石桥", Name: "Dashiqiao" },
  { Id: 969, ChineseName: "荥阳", Name: "Xingyang" },
  { Id: 970, ChineseName: "永州", Name: "Yongzhou" },
  { Id: 973, ChineseName: "龙游", Name: "Longyou" },
  { Id: 975, ChineseName: "都匀", Name: "Duyun" },
  { Id: 985, ChineseName: "曲靖", Name: "Qujing" },
  { Id: 986, ChineseName: "镇远", Name: "Zhenyuan" },
  { Id: 992, ChineseName: "鄂州", Name: "Ezhou" },
  { Id: 1005, ChineseName: "宁国", Name: "Ningguo" },
  { Id: 1006, ChineseName: "宣城", Name: "Xuancheng" },
  { Id: 1021, ChineseName: "定西", Name: "Dingxi" },
  { Id: 1023, ChineseName: "灵宝", Name: "Lingbao" },
  { Id: 1024, ChineseName: "马鞍山", Name: "Ma'anshan" },
  { Id: 1030, ChineseName: "渭南", Name: "Weinan" },
  { Id: 1037, ChineseName: "海阳", Name: "Haiyang" },
  { Id: 1038, ChineseName: "莱阳", Name: "Laiyang" },
  { Id: 1040, ChineseName: "高密", Name: "Gaomi" },
  { Id: 1043, ChineseName: "胶州", Name: "Jiaozhou" },
  { Id: 1044, ChineseName: "青州", Name: "Qingzhou" },
  { Id: 1048, ChineseName: "铁岭", Name: "Tieling" },
  { Id: 1050, ChineseName: "葫芦岛", Name: "Huludao" },
  { Id: 1051, ChineseName: "兴城", Name: "Xingcheng" },
  { Id: 1052, ChineseName: "昌黎", Name: "Changli" },
  { Id: 1054, ChineseName: "江油", Name: "Jiangyou" },
  { Id: 1060, ChineseName: "汝州", Name: "Rruzhou" },
  { Id: 1068, ChineseName: "霸州", Name: "Bazhou" },
  { Id: 1069, ChineseName: "任丘", Name: "Renqiu" },
  { Id: 1071, ChineseName: "聊城", Name: "Liaocheng" },
  { Id: 1073, ChineseName: "梁山", Name: "Liangshan" },
  { Id: 1074, ChineseName: "菏泽", Name: "Heze" },
  { Id: 1078, ChineseName: "亳州", Name: "Bozhou" },
  { Id: 1083, ChineseName: "满洲里", Name: "Manzhouli" },
  { Id: 1088, ChineseName: "漯河", Name: "Luohe" },
  { Id: 1092, ChineseName: "晋城", Name: "Jincheng" },
  { Id: 1093, ChineseName: "焦作", Name: "Jiaozuo" },
  { Id: 1094, ChineseName: "许昌", Name: "Xuchang" },
  { Id: 1097, ChineseName: "攀枝花", Name: "Panzhihua" },
  { Id: 1100, ChineseName: "广安", Name: "Guang'an" },
  { Id: 1105, ChineseName: "茂名", Name: "Maoming" },
  { Id: 1106, ChineseName: "日照", Name: "Rizhao" },
  { Id: 1108, ChineseName: "龙南", Name: "Longnan" },
  { Id: 1110, ChineseName: "吉首", Name: "Jishou" },
  { Id: 1111, ChineseName: "邵阳", Name: "Shaoyang" },
  { Id: 1113, ChineseName: "玉林", Name: "Yulin" },
  { Id: 1116, ChineseName: "白城", Name: "Baicheng" },
  { Id: 1117, ChineseName: "随州", Name: "Suizhou" },
  { Id: 1121, ChineseName: "荆门", Name: "Jingmen" },
  { Id: 1125, ChineseName: "益阳", Name: "Yiyang" },
  { Id: 1128, ChineseName: "绥化", Name: "Suihua" },
  { Id: 1133, ChineseName: "乌海", Name: "Wuhai" },
  { Id: 1136, ChineseName: "牙克石", Name: "Yakeshi" },
  { Id: 1139, ChineseName: "兴义", Name: "Xingyi" },
  { Id: 1140, ChineseName: "百色", Name: "Baise" },
  { Id: 1143, ChineseName: "加格达奇", Name: "Jiagedaqi" },
  { Id: 1148, ChineseName: "眉山", Name: "Meishan" },
  { Id: 1155, ChineseName: "本溪", Name: "Benxi" },
  { Id: 1158, ChineseName: "金昌", Name: "Jinchang" },
  { Id: 1177, ChineseName: "里诺", Name: "Reno" },
  { Id: 1178, ChineseName: "埃尔帕索", Name: "El Paso" },
  { Id: 1181, ChineseName: "密尔沃基", Name: "Milwaukee" },
  { Id: 1183, ChineseName: "圣路易斯", Name: "Saint Louis" },
  { Id: 1184, ChineseName: "辛辛那提", Name: "Cincinnati" },
  { Id: 1185, ChineseName: "克里夫兰", Name: "Cleveland" },
  { Id: 1186, ChineseName: "新奥尔良", Name: "New Orleans" },
  { Id: 1187, ChineseName: "奥兰多", Name: "Orlando" },
  { Id: 1188, ChineseName: "基韦斯特", Name: "Key West" },
  { Id: 1191, ChineseName: "圣巴巴拉", Name: "Santa Barbara" },
  { Id: 1192, ChineseName: "图森", Name: "Tucson" },
  { Id: 1193, ChineseName: "圣安东尼奥", Name: "San Antonio" },
  { Id: 1194, ChineseName: "剑桥", Name: "Cambridge" },
  { Id: 1195, ChineseName: "阿伯丁", Name: "Aberdeen" },
  { Id: 1198, ChineseName: "邓迪", Name: "Dundee" },
  { Id: 1199, ChineseName: "诺丁汉", Name: "Nottingham" },
  { Id: 1200, ChineseName: "盐城", Name: "Yancheng" },
  { Id: 1201, ChineseName: "宁海", Name: "Ninghai" },
  { Id: 1206, ChineseName: "平湖", Name: "Pinghu" },
  { Id: 1207, ChineseName: "马累", Name: "Male" },
  { Id: 1208, ChineseName: "慈溪", Name: "Cixi" },
  { Id: 1209, ChineseName: "临海", Name: "Linhai" },
  { Id: 1210, ChineseName: "黄金海岸", Name: "Gold Coast" },
  { Id: 1211, ChineseName: "代顿", Name: "Dayton" },
  { Id: 1212, ChineseName: "嵊州", Name: "Shengzhou" },
  { Id: 1216, ChineseName: "伊兹密尔", Name: "IZMIR" },
  { Id: 1217, ChineseName: "安塔利亚", Name: "Antalya" },
  { Id: 1218, ChineseName: "安卡拉", Name: "Ankara" },
  { Id: 1219, ChineseName: "武穴", Name: "Wuxue" },
  { Id: 1222, ChineseName: "稻城", Name: "Daocheng" },
  { Id: 1224, ChineseName: "仪征", Name: "Yizheng" },
  { Id: 1225, ChineseName: "兰卡威", Name: "Langkawi" },
  { Id: 1229, ChineseName: "苏梅岛", Name: "Koh Samui" },
  { Id: 1231, ChineseName: "里斯本", Name: "Lisbon" },
  { Id: 1232, ChineseName: "濮阳", Name: "Puyang" },
  { Id: 1233, ChineseName: "达州", Name: "Dazhou" },
  { Id: 1234, ChineseName: "孟菲斯", Name: "Memphis" },
  { Id: 1235, ChineseName: "金奈", Name: "Chennai" },
  { Id: 1236, ChineseName: "临沧", Name: "Lincang" },
  { Id: 1238, ChineseName: "明尼阿波利斯", Name: "Minneapolis" },
  { Id: 1239, ChineseName: "宿务", Name: "Cebu" },
  { Id: 1240, ChineseName: "博洛尼亚", Name: "Bologna" },
  { Id: 1242, ChineseName: "哈里法克斯", Name: "HALIFAX" },
  { Id: 1243, ChineseName: "阿德莱德", Name: "Adelaide" },
  { Id: 1244, ChineseName: "泗水", Name: "Surabaya" },
  { Id: 1245, ChineseName: "埃德蒙顿", Name: "Edmonton" },
  { Id: 1248, ChineseName: "汉诺威", Name: "Hannover" },
  { Id: 1249, ChineseName: "关丹", Name: "Kuantan" },
  { Id: 1250, ChineseName: "圣何塞", Name: "SAN JOSE" },
  { Id: 1251, ChineseName: "特古西加尔巴", Name: "tegucigalpa" },
  { Id: 1253, ChineseName: "瓜达拉哈拉", Name: "GUADALAJARA" },
  { Id: 1254, ChineseName: "拉巴斯", Name: "La Paz" },
  { Id: 1255, ChineseName: "巴西利亚", Name: "BRASILIA" },
  { Id: 1256, ChineseName: "马瑙斯", Name: "MANAUS" },
  { Id: 1257, ChineseName: "累西腓", Name: "RECIFE" },
  { Id: 1266, ChineseName: "卢布尔雅那", Name: "ljubljana" },
  { Id: 1267, ChineseName: "帕尔马", Name: "Palma de Mallorca" },
  { Id: 1268, ChineseName: "马拉加", Name: "malaga" },
  { Id: 1270, ChineseName: "伯明翰", Name: "Birmingham" },
  { Id: 1271, ChineseName: "阿尔及尔", Name: "Algiers" },
  { Id: 1274, ChineseName: "阿克拉", Name: "Accra" },
  { Id: 1277, ChineseName: "基加利", Name: "Kigali" },
  { Id: 1278, ChineseName: "德班", Name: "durban" },
  { Id: 1280, ChineseName: "突尼斯", Name: "Tunis" },
  { Id: 1281, ChineseName: "恩德培", Name: "Entebbe" },
  { Id: 1282, ChineseName: "安曼", Name: "Amman" },
  { Id: 1283, ChineseName: "鄂木斯克", Name: "OMSK" },
  { Id: 1287, ChineseName: "大邱", Name: "Daegu" },
  { Id: 1288, ChineseName: "布拉格", Name: "Prague" },
  { Id: 1289, ChineseName: "纽卡斯尔", Name: "Newcastle" },
  { Id: 1291, ChineseName: "印第安纳波利斯", Name: "Indianapolis" },
  { Id: 1293, ChineseName: "阿利坎特", Name: "Alicante" },
  { Id: 1294, ChineseName: "蒙彼利埃", Name: "Montpellier" },
  { Id: 1297, ChineseName: "达尼丁", Name: "DUNEDIN" },
  { Id: 1300, ChineseName: "营口", Name: "Yingkou" },
  { Id: 1303, ChineseName: "松原", Name: "Songyuan" },
  { Id: 1315, ChineseName: "永济", Name: "Yongji" },
  { Id: 1317, ChineseName: "朔州", Name: "Shuozhou" },
  { Id: 1322, ChineseName: "东明", Name: "Dongmingxian" },
  { Id: 1325, ChineseName: "奎屯", Name: "Kuitun" },
  { Id: 1341, ChineseName: "红河", Name: "Honghezhou" },
  { Id: 1343, ChineseName: "克拉特夫", Name: "KRAKOW" },
  { Id: 1345, ChineseName: "阿斯图里亚斯", Name: "asturias" },
  { Id: 1347, ChineseName: "比萨", Name: "pisa" },
  { Id: 1350, ChineseName: "塞维利亚", Name: "Sevilla" },
  { Id: 1351, ChineseName: "瓦伦西亚", Name: "valencia" },
  { Id: 1354, ChineseName: "斯特拉斯堡", Name: "Strasbourg" },
  { Id: 1355, ChineseName: "班加罗尔", Name: "Bangalore" },
  { Id: 1356, ChineseName: "岘港", Name: "Da Nang" },
  { Id: 1357, ChineseName: "吉大港", Name: "Chittagong" },
  { Id: 1358, ChineseName: "溧阳", Name: "Liyang" },
  { Id: 1359, ChineseName: "不来梅", Name: "Bremen" },
  { Id: 1360, ChineseName: "马拉喀什", Name: "MARRAKECH" },
  { Id: 1361, ChineseName: "图卢兹", Name: "Toulouse" },
  { Id: 1362, ChineseName: "多巴哥岛", Name: "TOBAGO" },
  {
    Id: 1363,
    ChineseName: "提鲁瓦南萨普拉姆",
    Name: "THIRUVANANTHAPURAM",
  },
  { Id: 1364, ChineseName: "海得拉巴", Name: "Hyderabad" },
  { Id: 1367, ChineseName: "德清", Name: "Deqing" },
  { Id: 1369, ChineseName: "暹粒", Name: "Siem Reap" },
  { Id: 1370, ChineseName: "德州", Name: "Dezhou" },
  { Id: 1371, ChineseName: "遂宁", Name: "Suining" },
  { Id: 1372, ChineseName: "松潘", Name: "Songpan" },
  { Id: 1373, ChineseName: "连城", Name: "Liancheng" },
  { Id: 1375, ChineseName: "怡保", Name: "IPOH" },
  { Id: 1376, ChineseName: "新山", Name: "JOHOR BAHRU" },
  { Id: 1377, ChineseName: "哥打巴鲁", Name: "KOTA BHARU" },
  { Id: 1380, ChineseName: "棉兰", Name: "Medan" },
  { Id: 1382, ChineseName: "山打根", Name: "SANDAKAN" },
  { Id: 1384, ChineseName: "古晋", Name: "Kuching" },
  { Id: 1385, ChineseName: "拉布安", Name: "labuan" },
  { Id: 1387, ChineseName: "斗湖", Name: "Tawau" },
  { Id: 1392, ChineseName: "龙目岛", Name: "Lombok" },
  { Id: 1393, ChineseName: "哥打京那巴鲁", Name: "Kota Kinabalu" },
  { Id: 1394, ChineseName: "的里雅斯特", Name: "TRIESTE" },
  { Id: 1395, ChineseName: "阿伦敦", Name: "Allentown" },
  { Id: 1396, ChineseName: "圣塔安那", Name: "Santa Ana" },
  { Id: 1397, ChineseName: "麦迪逊", Name: "Madison" },
  { Id: 1399, ChineseName: "坦帕", Name: "Tampa" },
  { Id: 1400, ChineseName: "斯波坎", Name: "Spokane" },
  { Id: 1401, ChineseName: "多哈", Name: "Doha" },
  { Id: 1405, ChineseName: "甲米", Name: "KRABI" },
  { Id: 1406, ChineseName: "罗利", Name: "Raleigh" },
  { Id: 1410, ChineseName: "卡托维茨", Name: "katowice" },
  { Id: 1411, ChineseName: "多特蒙德", Name: "dortmund" },
  { Id: 1412, ChineseName: "德雷斯顿", Name: "dresden" },
  { Id: 1413, ChineseName: "腓特烈港", Name: "FRIEDRICHSHAFEN" },
  { Id: 1415, ChineseName: "奥格斯堡", Name: "Augsburg" },
  { Id: 1416, ChineseName: "帕特泊恩", Name: "paderborn" },
  { Id: 1418, ChineseName: "萨格勒布", Name: "Zagreb" },
  { Id: 1419, ChineseName: "卡塔尼亚", Name: "Catania" },
  { Id: 1420, ChineseName: "维罗纳", Name: "Verona" },
  { Id: 1422, ChineseName: "清远", Name: "Qingyuan" },
  { Id: 1425, ChineseName: "奥马哈", Name: "Omaha" },
  { Id: 1428, ChineseName: "恩平", Name: "Enping" },
  { Id: 1429, ChineseName: "里米尼", Name: "Rimini" },
  { Id: 1430, ChineseName: "安科纳", Name: "ANCONA" },
  { Id: 1431, ChineseName: "巴里", Name: "BARI" },
  { Id: 1432, ChineseName: "卡利亚里", Name: "CAGLIARI" },
  { Id: 1433, ChineseName: "热那亚", Name: "Genoa" },
  { Id: 1434, ChineseName: "温尼伯", Name: "WINNIPEG" },
  { Id: 1436, ChineseName: "汕尾", Name: "Shanwei" },
  { Id: 1438, ChineseName: "莫林", Name: "Moline" },
  { Id: 1440, ChineseName: "俄克拉何马城", Name: "Oklahoma City" },
  { Id: 1441, ChineseName: "奥尔堡", Name: "AALBORG" },
  { Id: 1443, ChineseName: "泰顺", Name: "Taishun" },
  { Id: 1446, ChineseName: "霍巴特", Name: "Hobart" },
  { Id: 1448, ChineseName: "弗罗茨瓦夫", Name: "WROCLAW" },
  { Id: 1451, ChineseName: "因斯布鲁克", Name: "INNSBRUCK" },
  { Id: 1453, ChineseName: "晋中", Name: "Jinzhong" },
  { Id: 1454, ChineseName: "济源", Name: "Jiyuan" },
  { Id: 1458, ChineseName: "达沃", Name: "Davao" },
  { Id: 1460, ChineseName: "巴尔的摩", Name: "Baltimore" },
  { Id: 1461, ChineseName: "格但斯克", Name: "GDANSK" },
  { Id: 1462, ChineseName: "里尔", Name: "LILLE" },
  { Id: 1463, ChineseName: "波兹南", Name: "POZNAN" },
  { Id: 1464, ChineseName: "诺维奇", Name: "NORWICH" },
  { Id: 1466, ChineseName: "安图", Name: "Antu" },
  { Id: 1468, ChineseName: "巨港", Name: "PALEMBANG" },
  { Id: 1472, ChineseName: "宿迁", Name: "Suqian" },
  { Id: 1473, ChineseName: "雷恩", Name: "RENNES" },
  { Id: 1474, ChineseName: "丰宁", Name: "Fengning" },
  { Id: 1475, ChineseName: "加帝夫", Name: "CARDIFF" },
  { Id: 1476, ChineseName: "克里斯蒂安桑", Name: "KRISTIANSAND" },
  { Id: 1479, ChineseName: "万伦", Name: "SURAT THANI" },
  { Id: 1481, ChineseName: "董里", Name: "Trang" },
  { Id: 1482, ChineseName: "瓜亚基尔", Name: "GUAYAQUIL" },
  { Id: 1484, ChineseName: "南特", Name: "Nantes" },
  { Id: 1485, ChineseName: "滦平", Name: "Luanping" },
  { Id: 1489, ChineseName: "亚历山大", Name: "Alexandria" },
  { Id: 1490, ChineseName: "孝感", Name: "Xiaogan" },
  { Id: 1501, ChineseName: "高碑店", Name: "Gaobeidian" },
  { Id: 1509, ChineseName: "怀仁", Name: "Huairen" },
  { Id: 1518, ChineseName: "贵港", Name: "Guigang" },
  { Id: 1521, ChineseName: "赤壁", Name: "Chibi" },
  { Id: 1522, ChineseName: "涞源", Name: "Laiyuan" },
  { Id: 1541, ChineseName: "白银", Name: "Baiyin" },
  { Id: 1560, ChineseName: "资阳", Name: "Ziyang" },
  { Id: 1565, ChineseName: "开原", Name: "Kaiyuan" },
  { Id: 1597, ChineseName: "内江", Name: "Neijiang" },
  { Id: 1599, ChineseName: "七台河", Name: "Qitaihe" },
  { Id: 1611, ChineseName: "鹤岗", Name: "Hegang" },
  { Id: 1617, ChineseName: "双鸭山", Name: "Shuangyashan" },
  { Id: 1622, ChineseName: "富锦", Name: "Fujin" },
  { Id: 1632, ChineseName: "三河", Name: "sanheshi" },
  { Id: 1638, ChineseName: "新民", Name: "Xinmin" },
  { Id: 1654, ChineseName: "磐石", Name: "Panshi" },
  { Id: 1658, ChineseName: "阿尔山", Name: "Aershan" },
  { Id: 1677, ChineseName: "防城港", Name: "Fangchenggang" },
  { Id: 1705, ChineseName: "六安", Name: "Luan" },
  { Id: 1708, ChineseName: "荔波", Name: "libo" },
  { Id: 1709, ChineseName: "比隆", Name: "Billund" },
  { Id: 1712, ChineseName: "阿雅克肖", Name: "AJACCIO" },
  { Id: 1713, ChineseName: "亚维侬", Name: "AVIGNON" },
  { Id: 1714, ChineseName: "巴斯蒂亚", Name: "BASTIA" },
  { Id: 1715, ChineseName: "比亚里茨", Name: "BIARRITZ" },
  { Id: 1719, ChineseName: "格勒诺布尔", Name: "GRENOBLE" },
  { Id: 1722, ChineseName: "米卢斯", Name: "Mulhouse" },
  { Id: 1724, ChineseName: "安奈斯", Name: "ANNECY" },
  { Id: 1725, ChineseName: "佩皮尼扬", Name: "PERPIGNAN" },
  { Id: 1726, ChineseName: "波城", Name: "PAU" },
  { Id: 1729, ChineseName: "土伦", Name: "TOULON" },
  { Id: 1730, ChineseName: "因佛内斯", Name: "Inverness" },
  {
    Id: 1731,
    ChineseName: "爱因霍温",
    Name: "Eindhoven",
    country: "Netherlands",
  },
  { Id: 1733, ChineseName: "利兹", Name: "Leeds" },
  { Id: 1734, ChineseName: "特隆赫姆", Name: "TRONDHEIM" },
  { Id: 1735, ChineseName: "山达霍得", Name: "SANDEFJORD" },
  { Id: 1736, ChineseName: "彼尔姆", Name: "PERM" },
  { Id: 1737, ChineseName: "塔林", Name: "TALLINN" },
  { Id: 1744, ChineseName: "维哥", Name: "VIGO" },
  { Id: 1748, ChineseName: "阿达那", Name: "ADANA" },
  { Id: 1749, ChineseName: "达拉曼", Name: "DALAMAN" },
  { Id: 1753, ChineseName: "加济安泰普", Name: "GAZIANTEP" },
  { Id: 1756, ChineseName: "开塞利", Name: "KAYSERI" },
  { Id: 1757, ChineseName: "科尼亚", Name: "KONYA" },
  { Id: 1758, ChineseName: "萨姆松", Name: "SAMSUN" },
  { Id: 1760, ChineseName: "特拉布宗", Name: "TRABZON" },
  { Id: 1761, ChineseName: "博德鲁姆", Name: "BODRUM" },
  { Id: 1762, ChineseName: "代尼兹利", Name: "DENIZLI" },
  { Id: 1766, ChineseName: "兰萨罗特", Name: "LANZAROTE" },
  { Id: 1767, ChineseName: "安特卫普", Name: "Antwerp" },
  { Id: 1768, ChineseName: "伊比萨", Name: "Ibiza" },
  { Id: 1770, ChineseName: "喀山", Name: "Kazan" },
  { Id: 1772, ChineseName: "梅诺卡", Name: "MENORCA" },
  { Id: 1773, ChineseName: "塔斯卡卢萨", Name: "Tuscaloosa" },
  { Id: 1776, ChineseName: "顺化", Name: "Hue" },
  { Id: 1777, ChineseName: "芽庄", Name: "Nha Trang" },
  { Id: 1778, ChineseName: "卡利博", Name: "KALIBO" },
  { Id: 1780, ChineseName: "南萨哈林斯克", Name: "Yuzhno Sakhalinsk" },
  { Id: 1781, ChineseName: "博伊西", Name: "Boise" },
  { Id: 1782, ChineseName: "下诺夫哥罗德", Name: "Nizhny Novgorod" },
  { Id: 1783, ChineseName: "伊伐洛", Name: "IVALO" },
  { Id: 1784, ChineseName: "约恩苏", Name: "JOENSUU" },
  { Id: 1791, ChineseName: "库奥皮欧", Name: "KUOPIO" },
  { Id: 1793, ChineseName: "奥卢", Name: "OULU" },
  { Id: 1794, ChineseName: "罗瓦涅米", Name: "ROVANIEMI" },
  { Id: 1795, ChineseName: "图尔库", Name: "TURKU" },
  { Id: 1796, ChineseName: "坦佩雷", Name: "TAMPERE" },
  { Id: 1797, ChineseName: "瓦萨", Name: "VAASA" },
  { Id: 1802, ChineseName: "小松", Name: "KOMATSU" },
  { Id: 1803, ChineseName: "晋江", Name: "Jinjiang" },
  { Id: 1804, ChineseName: "莱西", Name: "laixi" },
  { Id: 1806, ChineseName: "怒江", Name: "nujiang" },
  { Id: 1807, ChineseName: "罗托鲁瓦", Name: "Rotorua" },
  { Id: 1817, ChineseName: "蒂米什瓦拉", Name: "TIMISOARA" },
  { Id: 1819, ChineseName: "腾冲", Name: "tengchong" },
  { Id: 1820, ChineseName: "滨州", Name: "binzhou" },
  { Id: 1823, ChineseName: "象山", Name: "Xiangshan" },
  { Id: 1833, ChineseName: "特拉帕尼", Name: "Trapani" },
  { Id: 1838, ChineseName: "阿坝", Name: "abazhou" },
  { Id: 1840, ChineseName: "萍乡", Name: "Pingxiang" },
  { Id: 1847, ChineseName: "比灵斯", Name: "Billings" },
  { Id: 1848, ChineseName: "阿尔伯克基", Name: "Albuquerque" },
  { Id: 1856, ChineseName: "威奇托市", Name: "Wichita" },
  { Id: 1857, ChineseName: "塔尔萨", Name: "Tulsa" },
  { Id: 1866, ChineseName: "斯泰特科利奇", Name: "State College" },
  { Id: 1867, ChineseName: "哈里斯堡", Name: "Harrisburg" },
  { Id: 1869, ChineseName: "温斯顿 塞勒姆", Name: "Winston Salem" },
  { Id: 1872, ChineseName: "迈尔斯堡", Name: "Fort Myers" },
  { Id: 1873, ChineseName: "西棕榈滩", Name: "West Palm Beach" },
  { Id: 1880, ChineseName: "圣何塞", Name: "San Jose" },
  { Id: 1881, ChineseName: "萨克拉门托", Name: "Sacramento" },
  { Id: 1882, ChineseName: "仙桃", Name: "Xiantao" },
  { Id: 1884, ChineseName: "肥城", Name: "feicheng" },
  { Id: 1892, ChineseName: "来宾", Name: "Laibin" },
  { Id: 1896, ChineseName: "崇左", Name: "Chongzuo" },
  { Id: 1899, ChineseName: "钦州", Name: "Qinzhou" },
  { Id: 2229, ChineseName: "阿图什", Name: "Atushi" },
  { Id: 2230, ChineseName: "迁安", Name: "Qianan" },
  { Id: 2542, ChineseName: "德令哈", Name: "Delingha" },
  { Id: 2548, ChineseName: "博乐", Name: "Bole" },
  { Id: 2594, ChineseName: "东山", Name: "Dongshan" },
  { Id: 2886, ChineseName: "闻喜", Name: "Wenxi" },
  { Id: 3053, ChineseName: "梅州", Name: "Meizhou" },
  { Id: 3115, ChineseName: "香农", Name: "Shannon" },
  { Id: 3139, ChineseName: "马默斯莱克斯", Name: "Mammoth Lakes" },
  { Id: 3174, ChineseName: "拉斯帕尔马斯", Name: "Las Palmas" },
  { Id: 3176, ChineseName: "桑坦德", Name: "Santander" },
  { Id: 3178, ChineseName: "吉罗那", Name: "Girona" },
  { Id: 3181, ChineseName: "帕特雷", Name: "Patrai" },
  { Id: 3185, ChineseName: "切斯特", Name: "Chester" },
  { Id: 3187, ChineseName: "利物浦", Name: "Liverpool" },
  { Id: 3194, ChineseName: "伯恩矛斯", Name: "Bournemouth" },
  { Id: 3221, ChineseName: "周口", Name: "zhoukou" },
  { Id: 3222, ChineseName: "平顶山", Name: "pingdingshan" },
  { Id: 3228, ChineseName: "纳什维尔", Name: "Nashville" },
  { Id: 3229, ChineseName: "芷江", Name: "zhijiang" },
  { Id: 3230, ChineseName: "句容", Name: "Jurong" },
  { Id: 3233, ChineseName: "东台", Name: "dongtai" },
  { Id: 3236, ChineseName: "小石城", Name: "Little rock" },
  { Id: 3239, ChineseName: "格林威尔", Name: "Greeleyville" },
  { Id: 3240, ChineseName: "查尔斯顿", Name: "CHARLESTON" },
  { Id: 3244, ChineseName: "阿布贾", Name: "ABUJA" },
  { Id: 3245, ChineseName: "埃里温", Name: "Yerevan" },
  { Id: 3248, ChineseName: "南本德", Name: "SOUTH BEND" },
  { Id: 3263, ChineseName: "阿斯塔纳", Name: "Astana" },
  { Id: 3264, ChineseName: "斯普利特", Name: "SPLIT" },
  { Id: 3265, ChineseName: "阿比让", Name: "Abidjan" },
  { Id: 3272, ChineseName: "欧德萨", Name: "Odessa" },
  { Id: 3275, ChineseName: "阆中", Name: "langzhong" },
  { Id: 3277, ChineseName: "雅安", Name: "yaan" },
  { Id: 3282, ChineseName: "卢本巴希", Name: "LUBUMBASHI" },
  { Id: 3288, ChineseName: "齐普尔", Name: "JAIPUR" },
  { Id: 3291, ChineseName: "帕福斯", Name: "PAPHOS" },
  { Id: 3292, ChineseName: "什里夫波特", Name: "Shreveport" },
  { Id: 3293, ChineseName: "克久拉霍", Name: "Khajuraho" },
  { Id: 3294, ChineseName: "西哈努克港", Name: "Sihanoukville" },
  {
    Id: 3297,
    ChineseName: "第聂伯罗彼得罗夫斯克",
    Name: "DNEPROPETROVSK",
  },
  { Id: 3298, ChineseName: "丰沙尔", Name: "FUNCHAL" },
  { Id: 3299, ChineseName: "哈尔科夫", Name: "Kharkiv" },
  { Id: 3300, ChineseName: "克拉斯诺达尔", Name: "KRASNODAR" },
  { Id: 3301, ChineseName: "罗斯托夫", Name: "ROSTOV" },
  { Id: 3302, ChineseName: "锡比乌", Name: "SIBIU" },
  { Id: 3303, ChineseName: "瓦尔纳", Name: "VARNA" },
  { Id: 3305, ChineseName: "特拉弗斯城", Name: "TRAVERSE CITY" },
  { Id: 3307, ChineseName: "基希讷乌", Name: "CHISINAU" },
  { Id: 3310, ChineseName: "乔普林", Name: "JOPLIN" },
  { Id: 3314, ChineseName: "卡鲁普", Name: "KARUP" },
  { Id: 3318, ChineseName: "阿格拉", Name: "Agra" },
  { Id: 3322, ChineseName: "彭萨科拉", Name: "PENSACOLA" },
  { Id: 3324, ChineseName: "奥胡斯", Name: "Aarhus" },
  { Id: 3330, ChineseName: "拿骚", Name: "NASSAU" },
  { Id: 3340, ChineseName: "达曼", Name: "Dammam" },
  { Id: 3345, ChineseName: "尚佩恩", Name: "Champaign" },
  { Id: 3347, ChineseName: "蒙哥马利", Name: "Montgomery" },
  { Id: 3354, ChineseName: "桑德贝", Name: "Thunder Bay" },
  { Id: 3356, ChineseName: "查塔努加", Name: "Chattanooga" },
  { Id: 3358, ChineseName: "法戈", Name: "Fargo" },
  { Id: 3360, ChineseName: "那拉提", Name: "Nalati" },
  { Id: 3362, ChineseName: "萨吉诺", Name: "Saginaw" },
  { Id: 3363, ChineseName: "巴吞鲁日", Name: "Baton Rouge" },
  { Id: 3366, ChineseName: "迈克艾伦", Name: "Mcallen" },
  { Id: 3383, ChineseName: "埃文斯维尔", Name: "Evansville" },
  { Id: 3392, ChineseName: "哈伊马角", Name: "Ras Al Khaimah" },
  { Id: 3396, ChineseName: "马德普拉塔", Name: "Mar del Plata" },
  { Id: 3397, ChineseName: "门多查", Name: "Mendoza" },
  { Id: 3398, ChineseName: "特雷利乌", Name: "Trelew" },
  { Id: 3399, ChineseName: "萨尔塔", Name: "Salta" },
  { Id: 3400, ChineseName: "乌斯怀亚", Name: "Ushuaia" },
  { Id: 3404, ChineseName: "爱丽斯泉", Name: "Alice Springs" },
  { Id: 3425, ChineseName: "普罗夫迪夫", Name: "Plovdiv" },
  { Id: 3428, ChineseName: "福特莱萨", Name: "Fortaleza" },
  { Id: 3430, ChineseName: "马塞约", Name: "Maceio" },
  { Id: 3431, ChineseName: "纳塔尔", Name: "Natal" },
  { Id: 3434, ChineseName: "萨尔瓦多", Name: "Salvador" },
  { Id: 3440, ChineseName: "坎卢普斯", Name: "Kamloops" },
  { Id: 3447, ChineseName: "拉罗汤加岛", Name: "Rarotonga" },
  { Id: 3455, ChineseName: "布尔诺", Name: "Brno" },
  { Id: 3463, ChineseName: "莱比锡", Name: "Leipzig" },
  { Id: 3464, ChineseName: "曼海姆", Name: "Mannheim" },
  { Id: 3471, ChineseName: "赫尔格达", Name: "Hurghada" },
  { Id: 3481, ChineseName: "圣塞瓦斯蒂安", Name: "San Sebastian" },
  { Id: 3488, ChineseName: "阿尔梅里亚", Name: "Almeria" },
  { Id: 3490, ChineseName: "洛格罗尼奥", Name: "Logrono" },
  { Id: 3496, ChineseName: "穆尔西亚", Name: "Murcia" },
  {
    Id: 3508,
    ChineseName: "特内利费- 圣克鲁斯",
    Name: "Santa Cruz de Tenerife",
  },
  { Id: 3519, ChineseName: "萨拉戈萨", Name: "Zaragoza" },
  { Id: 3522, ChineseName: "苏瓦", Name: "Suva" },
  { Id: 3534, ChineseName: "卢尔德", Name: "Lourdes" },
  { Id: 3547, ChineseName: "格劳斯特", Name: "Gloucester" },
  { Id: 3551, ChineseName: "伦敦德里", Name: "Londonderry" },
  { Id: 3559, ChineseName: "纽基", Name: "Newquay" },
  { Id: 3570, ChineseName: "罗得岛", Name: "Rhodes" },
  { Id: 3584, ChineseName: "萨洛尼卡", Name: "Thessaloniki" },
  { Id: 3590, ChineseName: "巴淡岛", Name: "Batam" },
  { Id: 3607, ChineseName: "埃拉特", Name: "Eilat" },
  { Id: 3622, ChineseName: "菠罗奈斯", Name: "Varanasi" },
  { Id: 3624, ChineseName: "阿尔盖罗", Name: "Alghero" },
  { Id: 3639, ChineseName: "佩鲁贾", Name: "Perugia" },
  { Id: 3640, ChineseName: "巴勒莫", Name: "Palermo" },
  { Id: 3677, ChineseName: "琅勃拉邦", Name: "Luang Prabang" },
  { Id: 3682, ChineseName: "阿加迪尔", Name: "Agadir" },
  { Id: 3683, ChineseName: "非斯", Name: "Fes" },
  { Id: 3685, ChineseName: "拉巴特", Name: "Rabat" },
  { Id: 3686, ChineseName: "丹吉尔", Name: "Tangier" },
  { Id: 3695, ChineseName: "印坦巴", Name: "Ixtapa" },
  { Id: 3696, ChineseName: "梅尼达", Name: "Merida" },
  { Id: 3697, ChineseName: "蒙特雷", Name: "Monterrey" },
  { Id: 3701, ChineseName: "巴亚以塔港", Name: "Puerto Vallarta" },
  { Id: 3713, ChineseName: "特罗姆瑟", Name: "Tromso" },
  { Id: 3717, ChineseName: "陶波", Name: "Taupo" },
  { Id: 3730, ChineseName: "卡斯凯斯", Name: "Cascais" },
  { Id: 3742, ChineseName: "雅西", Name: "Iasi" },
  { Id: 3746, ChineseName: "林雪平", Name: "Linkoping" },
  { Id: 3747, ChineseName: "马尔默", Name: "Malmo" },
  { Id: 3748, ChineseName: "厄勒布鲁", Name: "Orebro" },
  { Id: 3781, ChineseName: "劳德代尔堡", Name: "Fort Lauderdale" },
  { Id: 3789, ChineseName: "夏威夷·茂宜岛", Name: "Hawaii-Maui" },
  { Id: 3791, ChineseName: "夏威夷·可爱岛", Name: "Kauai" },
  { Id: 3799, ChineseName: "夏威夷·莫洛凯岛", Name: "Hawaii-Molokai" },
  { Id: 3804, ChineseName: "佩奇", Name: "Page" },
  {
    Id: 3811,
    ChineseName: "夏威夷·大岛",
    Name: "The Big Island (Hawaii island)",
  },
  { Id: 3827, ChineseName: "朗塞斯顿", Name: "Launceston" },
  { Id: 3838, ChineseName: "浦那", Name: "PUNE" },
  { Id: 3839, ChineseName: "那曲", Name: "naqu" },
  { Id: 3842, ChineseName: "林肯", Name: "LINCOLN" },
  { Id: 3847, ChineseName: "台南", Name: "Tainan" },
  { Id: 3848, ChineseName: "台东", Name: "Taitung" },
  { Id: 3849, ChineseName: "台中", Name: "Taichung" },
  { Id: 3852, ChineseName: "黎平", Name: "LIPING" },
  { Id: 3854, ChineseName: "科尔多瓦", Name: "Cordoba" },
  { Id: 3857, ChineseName: "南安普敦", Name: "SOUTHAMPTON" },
  { Id: 3860, ChineseName: "皇后镇", Name: "Queenstown" },
  { Id: 3862, ChineseName: "阿什贾巴特", Name: "ASHGABAT" },
  { Id: 3863, ChineseName: "寿光", Name: "shouguang" },
  { Id: 3872, ChineseName: "伊利", Name: "ERIE" },
  { Id: 3877, ChineseName: "马凯特", Name: "MARQUETTE" },
  { Id: 3878, ChineseName: "马斯基根", Name: "MUSKEGON" },
  { Id: 3881, ChineseName: "泗阳", Name: "siyang" },
  { Id: 3882, ChineseName: "塔拉哈西", Name: "TALLAHASSEE" },
  { Id: 3884, ChineseName: "抚州", Name: "Fuzhou" },
  { Id: 3885, ChineseName: "黄冈", Name: "Huanggang" },
  { Id: 3886, ChineseName: "白山", Name: "baishan" },
  { Id: 3887, ChineseName: "巴彦淖尔", Name: "Bayan Nur" },
  { Id: 3896, ChineseName: "尤金", Name: "EUGENE" },
  { Id: 3900, ChineseName: "韦恩堡", Name: "Fort wayne" },
  { Id: 3901, ChineseName: "杜布罗夫尼克", Name: "DUBROVNIK" },
  { Id: 3902, ChineseName: "乌法", Name: "UFA" },
  { Id: 3904, ChineseName: "爱尔福特", Name: "ERFURT" },
  { Id: 3910, ChineseName: "湘西", Name: "xiangxi" },
  { Id: 3914, ChineseName: "大冶", Name: "daye" },
  { Id: 3915, ChineseName: "莱州", Name: "Laizhou" },
  { Id: 3917, ChineseName: "福清", Name: "Fuqing" },
  { Id: 3920, ChineseName: "天门", Name: "Tianmen" },
  { Id: 3923, ChineseName: "海安", Name: "Hai'an" },
  { Id: 3926, ChineseName: "靖江", Name: "jingjiang" },
  { Id: 3927, ChineseName: "德兴", Name: "dexing" },
  { Id: 3933, ChineseName: "云浮", Name: "yunfu" },
  { Id: 3937, ChineseName: "扬中", Name: "yangzhong" },
  { Id: 3938, ChineseName: "钟祥", Name: "zhongxiang" },
  { Id: 3943, ChineseName: "平度", Name: "pingdu" },
  { Id: 3945, ChineseName: "雷焦卡拉布里亚", Name: "REGGIO CALABRIA" },
  { Id: 3946, ChineseName: "龙口", Name: "longkou" },
  { Id: 3966, ChineseName: "巴中", Name: "bazhong" },
  { Id: 3969, ChineseName: "河池", Name: "hechi" },
  { Id: 3974, ChineseName: "俄斯特拉伐", Name: "OSTRAVA" },
  { Id: 3975, ChineseName: "加里宁格勒", Name: "KALININGRAD" },
  { Id: 3976, ChineseName: "鄂尔多斯", Name: "Ordos" },
  { Id: 3978, ChineseName: "临夏市", Name: "Linxia" },
  { Id: 3980, ChineseName: "泰兴", Name: "Taixing" },
  { Id: 3981, ChineseName: "瓦多达拉", Name: "VADODARA" },
  { Id: 3984, ChineseName: "克拉克斯堡", Name: "CLARKSBURG" },
  { Id: 3985, ChineseName: "比亚埃尔莫萨", Name: "VILLAHERMOSA" },
  { Id: 3994, ChineseName: "尼尔森", Name: "NELSON" },
  { Id: 3996, ChineseName: "普洱", Name: "Pu'er" },
  { Id: 3997, ChineseName: "芒市", Name: "Mangshi" },
  { Id: 3999, ChineseName: "夏洛茨维尔", Name: "CHARLOTTESVILLE" },
  { Id: 4002, ChineseName: "塔拿那利佛", Name: "Antananarivo" },
  { Id: 4007, ChineseName: "阿普尔顿", Name: "APPLETON" },
  { Id: 4008, ChineseName: "布拉迪斯拉发", Name: "Bratislava" },
  { Id: 4009, ChineseName: "熊本", Name: "Kumamoto" },
  { Id: 4013, ChineseName: "夏津", Name: "xiajin" },
  { Id: 4015, ChineseName: "比得哥什", Name: "Bydgoszcz" },
  { Id: 4020, ChineseName: "永城", Name: "YongCheng" },
  { Id: 4023, ChineseName: "贝克斯菲尔德", Name: "Bakersfield" },
  { Id: 4024, ChineseName: "韦尔", Name: "Vail" },
  { Id: 4025, ChineseName: "卡提克兰", Name: "CATICLAN" },
  { Id: 4027, ChineseName: "爱妮岛", Name: "EL Nido" },
  { Id: 4028, ChineseName: "卡尔马", Name: "KALMAR" },
  { Id: 4048, ChineseName: "斯里巴加湾市", Name: "Bandar Seri Begawan" },
  { Id: 4049, ChineseName: "拉巴斯", Name: "La Paz" },
  { Id: 4062, ChineseName: "科尔玛", Name: "Colmar" },
  { Id: 4072, ChineseName: "佩斯卡拉", Name: "Pescara" },
  { Id: 4074, ChineseName: "蒙特哥湾", Name: "Montego Bay" },
  { Id: 4078, ChineseName: "圣卢西亚", Name: "Gros Islet" },
  { Id: 4079, ChineseName: "里加", Name: "Riga" },
  { Id: 4080, ChineseName: "曼德勒", Name: "Mandalay" },
  { Id: 4081, ChineseName: "塞班岛", Name: "Saipan" },
  { Id: 4090, ChineseName: "圣胡安", Name: "San Juan" },
  { Id: 4092, ChineseName: "波尔蒂芒", Name: "Portimao" },
  { Id: 4098, ChineseName: "苏恰瓦", Name: "Suceava" },
  { Id: 4100, ChineseName: "马埃岛", Name: "Mahe Island" },
  { Id: 4109, ChineseName: "吉尔巴岛", Name: "Djerba" },
  { Id: 4118, ChineseName: "伊丽莎白港", Name: "Port Elizabeth" },
  { Id: 4124, ChineseName: "甘孜", Name: "ganzizhou" },
  { Id: 4125, ChineseName: "高邮", Name: "gaoyou" },
  { Id: 4130, ChineseName: "康定", Name: "Kangding" },
  { Id: 4136, ChineseName: "新密", Name: "xinmi" },
  { Id: 4137, ChineseName: "珲春", Name: "hunchun" },
  { Id: 4139, ChineseName: "如皋", Name: "rugao" },
  { Id: 4141, ChineseName: "博兴", Name: "BOXING" },
  { Id: 4144, ChineseName: "诸城", Name: "ZHUCHENG" },
  { Id: 4146, ChineseName: "贺州", Name: "hezhou" },
  { Id: 4148, ChineseName: "奥尔比亚", Name: "Olbia" },
  { Id: 4153, ChineseName: "阿斯彭", Name: "Aspen" },
  { Id: 4154, ChineseName: "潜江", Name: "qianjiang" },
  { Id: 4155, ChineseName: "卡拉马祖", Name: "Kalamazoo" },
  { Id: 4158, ChineseName: "哥印拜陀", Name: "Coimbatore" },
  { Id: 4160, ChineseName: "杜尚别", Name: "Dushanbe" },
  { Id: 4162, ChineseName: "兰辛", Name: "Lansing" },
  { Id: 4163, ChineseName: "伽耶", Name: "Gaya" },
  { Id: 4165, ChineseName: "阿德列尔", Name: "Adler" },
  { Id: 4166, ChineseName: "杜兰戈", Name: "Durango" },
  { Id: 4168, ChineseName: "墨尔本", Name: "MELBOURNE" },
  { Id: 4172, ChineseName: "托莱多", Name: "TOLEDO" },
  { Id: 4174, ChineseName: "托莱多", Name: "TOLEDO" },
  { Id: 4175, ChineseName: "布琼布拉", Name: "Bujumbura" },
  { Id: 4185, ChineseName: "浏阳", Name: "Liuyang" },
  { Id: 4188, ChineseName: "查尔斯顿", Name: "Charleston" },
  { Id: 4192, ChineseName: "海得拉巴", Name: "Hyderabad" },
  { Id: 4199, ChineseName: "马什哈德", Name: "Mashhad" },
  { Id: 4202, ChineseName: "车里雅宾斯克", Name: "CHELYABINSK" },
  { Id: 4204, ChineseName: "叶卡捷琳堡", Name: "Yekaterinburg" },
  { Id: 4210, ChineseName: "费里敦", Name: "Freetown" },
  { Id: 4214, ChineseName: "桑给巴尔", Name: "Zanzibar" },
  { Id: 4218, ChineseName: "克拉斯诺雅尔斯克", Name: "Krasnoyarsk" },
  { Id: 4221, ChineseName: "阿巴坎", Name: "Abakan" },
  { Id: 4225, ChineseName: "伏尔加格勒", Name: "Volgograd" },
  { Id: 4226, ChineseName: "阿斯特拉罕", Name: "Astrakhan" },
  { Id: 4228, ChineseName: "巴尔瑙尔", Name: "Barnaul" },
  { Id: 4229, ChineseName: "克麦罗沃", Name: "Kemerovo" },
  { Id: 4234, ChineseName: "多森", Name: "Dothan" },
  { Id: 4235, ChineseName: "费尔班克斯", Name: "Fairbanks" },
  { Id: 4236, ChineseName: "奇科", Name: "Chico" },
  { Id: 4239, ChineseName: "代托纳比奇", Name: "Daytona beach" },
  { Id: 4241, ChineseName: "纳奈莫", Name: "Nanaimo" },
  { Id: 4250, ChineseName: "乔治城", Name: "George" },
  { Id: 4255, ChineseName: "呼伦贝尔", Name: "Hulunbuir" },
  { Id: 4256, ChineseName: "隆内比", Name: "Ronneby" },
  { Id: 4261, ChineseName: "大西洋城", Name: "ATLANTIC CITY" },
  { Id: 4271, ChineseName: "阿拉卡茄", Name: "ARACAJU" },
  { Id: 4273, ChineseName: "阿特卡", Name: "ATKA" },
  { Id: 4279, ChineseName: "阿基亚克", Name: "AKIAK" },
  { Id: 4280, ChineseName: "旭川", Name: "ASAHIKAWA" },
  { Id: 4281, ChineseName: "阿克希奥克", Name: "AKHIOK" },
  { Id: 4282, ChineseName: "金萨蒙", Name: "KING SALMON" },
  { Id: 4284, ChineseName: "阿纳克图沃克", Name: "ANAKTUVUK" },
  { Id: 4289, ChineseName: "阿库里维克", Name: "AKULIVIK" },
  { Id: 4294, ChineseName: "阿尔塔", Name: "ALTA" },
  { Id: 4312, ChineseName: "阿马里洛", Name: "AMARILLO" },
  { Id: 4334, ChineseName: "安托法加斯塔", Name: "ANTOFAGASTA" },
  { Id: 4337, ChineseName: "阿尼亚克", Name: "ANIAK" },
  { Id: 4343, ChineseName: "安维克", Name: "ANVIK" },
  { Id: 4364, ChineseName: "阿尔皮纳", Name: "ALPENA" },
  { Id: 4371, ChineseName: "阿皮亚", Name: "Apia" },
  { Id: 4375, ChineseName: "亚喀巴", Name: "AQABA" },
  { Id: 4379, ChineseName: "安阿伯", Name: "ANN ARBOR" },
  { Id: 4380, ChineseName: "北极村", Name: "ARCTIC VILLAGE" },
  { Id: 4384, ChineseName: "阿尔汉格尔斯克", Name: "ARKHANGELSK" },
  { Id: 4385, ChineseName: "阿里卡", Name: "ARICA" },
  { Id: 4387, ChineseName: "阿鲁沙", Name: "ARUSHA" },
  { Id: 4421, ChineseName: "阿特卡什克", Name: "ATQASUK" },
  { Id: 4426, ChineseName: "阿姆利则", Name: "AMRITSAR" },
  { Id: 4443, ChineseName: "阿拉克纳克", Name: "ALAKNUK" },
  { Id: 4462, ChineseName: "阿什维尔", Name: "ASHEVILLE" },
  { Id: 4478, ChineseName: "亚历山德鲁波利斯", Name: "ALEXANDROUPOLIS" },
  { Id: 4482, ChineseName: "阿尔梅尼亚", Name: "ARMENIA" },
  { Id: 4517, ChineseName: "巴兰基亚", Name: "BARRANQUILLA" },
  { Id: 4525, ChineseName: "巴尔马塞达", Name: "BALMACEDA" },
  { Id: 4533, ChineseName: "布巴内斯瓦尔", Name: "BHUBANESWAR" },
  { Id: 4550, ChineseName: "布莱克斯堡", Name: "BLACKSBURG" },
  { Id: 4588, ChineseName: "布林迪西", Name: "Brindisi" },
  { Id: 4589, ChineseName: "巴尔杜福斯", Name: "BARDUFOSS" },
  { Id: 4595, ChineseName: "本贝库拉", Name: "BENBECULA" },
  { Id: 4606, ChineseName: "贝瑟尔", Name: "BETHEL" },
  { Id: 4616, ChineseName: "布勒费尔德", Name: "BIELEFELD" },
  { Id: 4617, ChineseName: "斯科茨布拉夫", Name: "SCOTTSBLUFF" },
  { Id: 4620, ChineseName: "布隆方丹", Name: "BLOEMFONTEIN" },
  { Id: 4626, ChineseName: "武里南", Name: "BURI RAM" },
  { Id: 4628, ChineseName: "布卡拉曼加", Name: "BUCARAMANGA" },
  { Id: 4636, ChineseName: "布里奇敦", Name: "BRIDGETOWN" },
  { Id: 4650, ChineseName: "巴港", Name: "BAR HARBOR" },
  { Id: 4652, ChineseName: "布连海姆", Name: "BLENHEIM" },
  { Id: 4657, ChineseName: "普杰", Name: "BHUJ" },
  { Id: 4667, ChineseName: "包纳加尔", Name: "BHAVNAGAR" },
  { Id: 4669, ChineseName: "贝洛奥里藏特", Name: "BELO HORIZONTE" },
  { Id: 4683, ChineseName: "俾斯麦", Name: "BISMARCK" },
  { Id: 4685, ChineseName: "比尔都达勒尔", Name: "BILDUDALUR" },
  { Id: 4698, ChineseName: "伯米吉", Name: "Bemidji" },
  { Id: 4700, ChineseName: "班珠尔", Name: "BANJUL" },
  { Id: 4708, ChineseName: "莱昂", Name: "LEON" },
  { Id: 4729, ChineseName: "巴塞罗那", Name: "BARCELONA" },
  { Id: 4730, ChineseName: "巴尔博亚", Name: "BALBOA" },
  { Id: 4734, ChineseName: "布尔菲尔德", Name: "BLUEFIELD" },
  { Id: 4737, ChineseName: "贝灵厄姆", Name: "BELLINGHAM" },
  { Id: 4781, ChineseName: "巴利那", Name: "BALLINA" },
  { Id: 4806, ChineseName: "博多", Name: "BODO" },
  { Id: 4827, ChineseName: "塞古鲁港", Name: "PORTO SEGURO" },
  { Id: 4839, ChineseName: "伊丽莎白港", Name: "Port Elizabeth" },
  {
    Id: 4843,
    ChineseName: "圣卡洛斯.德巴里洛切",
    Name: "SAN CARLOS DE BARILOCHE",
  },
  { Id: 4853, ChineseName: "巴拉", Name: "BARRA" },
  { Id: 4856, ChineseName: "巴罗", Name: "BARROW" },
  { Id: 4887, ChineseName: "巴特岛", Name: "BARTER ISLAND" },
  { Id: 4889, ChineseName: "巴特尔克里克", Name: "BATTLE CREEK" },
  { Id: 4894, ChineseName: "贝特尔斯", Name: "BETTLES" },
  { Id: 4898, ChineseName: "布尔萨", Name: "Bursa" },
  { Id: 4912, ChineseName: "巴统", Name: "BATUMI" },
  { Id: 4920, ChineseName: "博阿维斯塔", Name: "BOA VISTA" },
  { Id: 4929, ChineseName: "巴特尔斯维尔", Name: "BARTLESVILLE" },
  { Id: 4942, ChineseName: "布劳恩史维希", Name: "BRAUNSCHWEIG" },
  { Id: 4947, ChineseName: "博尔", Name: "BOL" },
  { Id: 5005, ChineseName: "贝济耶", Name: "BEZIERS" },
  { Id: 5011, ChineseName: "坎贝尔镇", Name: "CAMPBELTOWN" },
  { Id: 5023, ChineseName: "科科岛", Name: "CAYO COCO" },
  { Id: 5025, ChineseName: "科泽科德", Name: "Kozhikode" },
  { Id: 5028, ChineseName: "康塞普西翁", Name: "CONCEPCION" },
  { Id: 5030, ChineseName: "科尔德湾", Name: "COLD BAY" },
  { Id: 5031, ChineseName: "锡达城", Name: "CEDAR CITY" },
  { Id: 5032, ChineseName: "沙德伦", Name: "CHADRON" },
  { Id: 5033, ChineseName: "科尔多瓦", Name: "CORDOVA" },
  { Id: 5034, ChineseName: "克雷申特城", Name: "CRESCENT CITY" },
  { Id: 5036, ChineseName: "切列波维茨", Name: "CHEREPOVETS" },
  { Id: 5042, ChineseName: "寒冷角", Name: "CABO FRIO" },
  { Id: 5044, ChineseName: "多尼戈尔", Name: "DONEGAL" },
  { Id: 5046, ChineseName: "克基拉", Name: "KERKYRA" },
  { Id: 5048, ChineseName: "库亚巴", Name: "CUIABA" },
  { Id: 5049, ChineseName: "开普吉拉多", Name: "CAPE GIRARDEAU" },
  { Id: 5052, ChineseName: "干尼亚", Name: "CHANIA" },
  { Id: 5054, ChineseName: "乔阿特巴芦克", Name: "CHUATHBALUK" },
  { Id: 5058, ChineseName: "查尔基齐克", Name: "CHALKYITSIK" },
  { Id: 5064, ChineseName: "卡拉马", Name: "CALAMA" },
  { Id: 5066, ChineseName: "青蓬", Name: "CHUMPHON" },
  { Id: 5067, ChineseName: "华雷斯城", Name: "CIUDAD JUAREZ" },
  { Id: 5069, ChineseName: "克鲁克特城", Name: "CROOKED CREEK" },
  { Id: 5072, ChineseName: "奇金", Name: "CHICKEN" },
  { Id: 5074, ChineseName: "克利奇站", Name: "COLLEGE STATION" },
  { Id: 5075, ChineseName: "安吉利斯港", Name: "PORT ANGELES" },
  { Id: 5076, ChineseName: "卡利", Name: "CALI" },
  { Id: 5077, ChineseName: "克拉克斯波因特", Name: "CLARKS POINT" },
  { Id: 5078, ChineseName: "科利马", Name: "COLIMA" },
  { Id: 5081, ChineseName: "尚贝里", Name: "CHAMBERY" },
  { Id: 5103, ChineseName: "坎佩切", Name: "CAMPECHE" },
  { Id: 5106, ChineseName: "卡斯珀", Name: "CASPER" },
  { Id: 5114, ChineseName: "科珀斯克里斯蒂", Name: "CORPUS CHRISTI" },
  { Id: 5116, ChineseName: "克罗托内", Name: "CROTONE" },
  { Id: 5118, ChineseName: "圣路易斯-奥比斯波", Name: "SAN LUIS OBISPO" },
  { Id: 5123, ChineseName: "卡塔赫纳", Name: "CARTAGENA" },
  { Id: 5132, ChineseName: "库利阿坎", Name: "CULIACAN" },
  { Id: 5137, ChineseName: "奇瓦瓦", Name: "CHIHUAHUA" },
  { Id: 5148, ChineseName: "科克斯巴扎尔", Name: "COX'S BAZAR" },
  { Id: 5149, ChineseName: "南卡希亚斯", Name: "CAXIAS DO SUL" },
  { Id: 5152, ChineseName: "嘉义", Name: "CHIAYI" },
  { Id: 5156, ChineseName: "夏延", Name: "CHEYENNE" },
  { Id: 5162, ChineseName: "科苏梅尔", Name: "COZUMEL" },
  { Id: 5170, ChineseName: "迪比克", Name: "DUBUQUE" },
  { Id: 5177, ChineseName: "迪凯特", Name: "DECATUR" },
  { Id: 5184, ChineseName: "杜马格特", Name: "DUMAGUETE" },
  { Id: 5190, ChineseName: "奠边府", Name: "DIEN BIEN PHU" },
  { Id: 5194, ChineseName: "第乌", Name: "DIU" },
  { Id: 5202, ChineseName: "迪灵汗", Name: "DILLINGHAM" },
  { Id: 5204, ChineseName: "大叻", Name: "DALAT" },
  { Id: 5212, ChineseName: "多维尔", Name: "DEAUVILLE" },
  { Id: 5223, ChineseName: "荷兰港", Name: "DUTCH HARBOR" },
  { Id: 5224, ChineseName: "德弗尔斯莱克", Name: "DEVILS LAKE" },
  { Id: 5233, ChineseName: "文纳奇", Name: "WENATCHEE" },
  { Id: 5234, ChineseName: "欧克莱尔", Name: "EAU CLAIRE" },
  { Id: 5238, ChineseName: "埃斯比约", Name: "ESBJERG" },
  { Id: 5242, ChineseName: "伊克", Name: "EEK" },
  { Id: 5243, ChineseName: "凯法利尼亚", Name: "KEFALLINIA" },
  { Id: 5244, ChineseName: "贝尔热拉克", Name: "BERGERAC" },
  { Id: 5248, ChineseName: "埃吉尔斯塔第尔", Name: "EGILSSTADIR" },
  { Id: 5250, ChineseName: "伊杰吉克", Name: "EGEGIK" },
  { Id: 5256, ChineseName: "埃尔科", Name: "ELKO" },
  { Id: 5263, ChineseName: "埃利姆", Name: "ELIM" },
  { Id: 5264, ChineseName: "艾尔迈拉", Name: "ELMIRA" },
  { Id: 5271, ChineseName: "埃莫纳克", Name: "EMMONAK" },
  { Id: 5274, ChineseName: "基奈", Name: "KENAI" },
  { Id: 5276, ChineseName: "埃代岛", Name: "EDAY" },
  { Id: 5277, ChineseName: "埃斯佩兰斯", Name: "ESPERANCE" },
  { Id: 5282, ChineseName: "马歇尔", Name: "MARSHALL" },
  { Id: 5283, ChineseName: "莫雷利亚", Name: "MORELIA" },
  { Id: 5285, ChineseName: "米洛斯", Name: "MILOS" },
  { Id: 5287, ChineseName: "曼利温泉", Name: "Manley Hot Springs" },
  { Id: 5291, ChineseName: "摩尔曼斯科", Name: "MURMANSK" },
  { Id: 5297, ChineseName: "明托", Name: "MINTO" },
  { Id: 5301, ChineseName: "莫比尔", Name: "Mobile County" },
  { Id: 5303, ChineseName: "莫德斯托", Name: "MODESTO" },
  { Id: 5309, ChineseName: "迈诺特", Name: "MINOT" },
  { Id: 5310, ChineseName: "芒廷村", Name: "MOUNTAIN VILLAGE" },
  { Id: 5343, ChineseName: "卡姆也拉", Name: "KAMUELA" },
  { Id: 5355, ChineseName: "马萨葡萄园", Name: "MARTHAS VINERYARD" },
  { Id: 5356, ChineseName: "马里恩", Name: "MARION" },
  { Id: 5359, ChineseName: "摩塞斯莱克", Name: "MOSES LAKE" },
  { Id: 5378, ChineseName: "默特尔比奇", Name: "MYRTLE BEACH" },
  { Id: 5380, ChineseName: "梅克茹余克", Name: "MEKORYUK" },
  { Id: 5385, ChineseName: "马尼萨莱斯", Name: "MANIZALES" },
  { Id: 5387, ChineseName: "马萨特蓝", Name: "MAZATLAN" },
  { Id: 5391, ChineseName: "那格浦尔", Name: "NAGPUR" },
  { Id: 5397, ChineseName: "吕宋岛", Name: "LUZON ISLAND" },
  { Id: 5421, ChineseName: "纳尔逊拉戈", Name: "NELSON LAGOON" },
  { Id: 5426, ChineseName: "奈特缪特", Name: "NIGHTMUTE" },
  { Id: 5428, ChineseName: "农多尔顿", Name: "NONDALTON" },
  { Id: 5433, ChineseName: "康诺特", Name: "KNOCK" },
  { Id: 5439, ChineseName: "纳皮尔-黑斯廷斯", Name: "NAPIER" },
  { Id: 5445, ChineseName: "诺尔雪平", Name: "NORRKOPING" },
  { Id: 5446, ChineseName: "北罗纳德赛（岛）", Name: "NORTH RONALDSAY" },
  { Id: 5449, ChineseName: "洛坤", Name: "Nakhon Si Thammarat" },
  { Id: 5456, ChineseName: "诺伊克索特", Name: "NUIQSUT" },
  { Id: 5457, ChineseName: "努拉托", Name: "NULATO" },
  { Id: 5458, ChineseName: "纽纳皮兹", Name: "NUNAPITCHUK" },
  { Id: 5462, ChineseName: "纳尔维克", Name: "NARVIK" },
  { Id: 5463, ChineseName: "纳韦甘蒂斯", Name: "NAVEGANTES" },
  { Id: 5472, ChineseName: "科伯克", Name: "KOBUK" },
  { Id: 5482, ChineseName: "奥赫里德", Name: "OHRID" },
  { Id: 5497, ChineseName: "诺姆", Name: "NOME" },
  { Id: 5505, ChineseName: "托克苏克", Name: "TOKSOOK BAY" },
  { Id: 5510, ChineseName: "伍斯特", Name: "WORCESTER" },
  { Id: 5511, ChineseName: "奥兰", Name: "ORAN" },
  { Id: 5516, ChineseName: "厄斯特松德", Name: "OSTERSUND" },
  { Id: 5523, ChineseName: "康塔多拉", Name: "CONTADORA" },
  { Id: 5524, ChineseName: "北本德", Name: "NORTH BEND" },
  { Id: 5527, ChineseName: "科策布", Name: "KOTZEBUE" },
  { Id: 5534, ChineseName: "奥克斯纳德", Name: "OXNARD" },
  { Id: 5538, ChineseName: "扎波罗热", Name: "ZAPOROZHYE" },
  { Id: 5543, ChineseName: "帕罗斯", Name: "PAROS" },
  { Id: 5544, ChineseName: "巴特那", Name: "PATNA" },
  { Id: 5560, ChineseName: "佩得罗贝", Name: "PEDRO BAY" },
  { Id: 5563, ChineseName: "埃斯特角城", Name: "PUNTA DEL ESTE" },
  { Id: 5568, ChineseName: "佩雷拉", Name: "PEREIRA" },
  { Id: 5576, ChineseName: "帕纳马城", Name: "PANAMA CITY" },
  { Id: 5580, ChineseName: "格雷厄姆港", Name: "PORT GRAHAM" },
  { Id: 5586, ChineseName: "波因特霍普", Name: "POINT HOPE" },
  { Id: 5587, ChineseName: "彭世洛", Name: "PHITSANULOK" },
  { Id: 5590, ChineseName: "波卡特洛", Name: "POCATELLO" },
  { Id: 5593, ChineseName: "皮尔", Name: "PIERRE" },
  { Id: 5595, ChineseName: "波因特莱", Name: "POINT LAY" },
  { Id: 5599, ChineseName: "纳帕斯杰克", Name: "NAPASKIAK" },
  { Id: 5600, ChineseName: "帕克斯堡", Name: "PARKERSBURG" },
  { Id: 5607, ChineseName: "巴色", Name: "PAKSE" },
  { Id: 5610, ChineseName: "佩尔斯顿", Name: "PELLSTON" },
  { Id: 5618, ChineseName: "蒙特港", Name: "PUERTO MONTT" },
  { Id: 5621, ChineseName: "北帕默斯顿", Name: "Palmerston North" },
  { Id: 5624, ChineseName: "马德林港", Name: "PUERTO MADRYN" },
  { Id: 5626, ChineseName: "潘普洛纳", Name: "PAMPLONA" },
  { Id: 5635, ChineseName: "阿雷格里港", Name: "PORTO ALEGRE" },
  { Id: 5638, ChineseName: "普拉塔港", Name: "PUERTO PLATA" },
  { Id: 5645, ChineseName: "普罗瑟派恩", Name: "PROSERPINE" },
  { Id: 5648, ChineseName: "帕帕韦斯特雷", Name: "PAPA WESTRAY" },
  { Id: 5649, ChineseName: "富国岛", Name: "Phu Quoc Island" },
  { Id: 5652, ChineseName: "派勒特斯泰特", Name: "PILOT STATION" },
  { Id: 5653, ChineseName: "普雷斯科特", Name: "PRESCOTT" },
  { Id: 5655, ChineseName: "普拉兰岛", Name: "PRASLIN ISLAND" },
  { Id: 5658, ChineseName: "蓬塞", Name: "PONCE" },
  { Id: 5659, ChineseName: "彼得斯堡", Name: "PETERSBURG" },
  { Id: 5670, ChineseName: "海登港", Name: "PORT HEIDEN" },
  { Id: 5674, ChineseName: "普拉蒂纳姆", Name: "PLATINUM" },
  { Id: 5675, ChineseName: "普韦布洛", Name: "PUEBLO" },
  { Id: 5677, ChineseName: "蓬塔卡纳", Name: "PUNTA CANA" },
  { Id: 5682, ChineseName: "普拉", Name: "PULA" },
  { Id: 5686, ChineseName: "普雷韦扎 莱夫卡斯", Name: "PREVEZA LEFKAS" },
  { Id: 5689, ChineseName: "埃斯康德港", Name: "PUERTO ESCONDIDO" },
  { Id: 5690, ChineseName: "圣港", Name: "PORTO SANTO" },
  { Id: 5691, ChineseName: "波来古", Name: "PLEIKU" },
  { Id: 5699, ChineseName: "贝拉库尔", Name: "BELLA COOLA" },
  { Id: 5709, ChineseName: "佩奇", Name: "Pecs" },
  { Id: 5724, ChineseName: "拉皮德城", Name: "RAPID CITY" },
  { Id: 5734, ChineseName: "鲁比", Name: "RUBY" },
  { Id: 5735, ChineseName: "里查兹贝", Name: "RICHARDS BAY" },
  { Id: 5740, ChineseName: "雷丁", Name: "Redding" },
  { Id: 5743, ChineseName: "雷德代夫尔", Name: "RED DEVIL" },
  { Id: 5748, ChineseName: "雷乌斯", Name: "REUS" },
  { Id: 5749, ChineseName: "雷诺萨", Name: "REYNOSA" },
  { Id: 5760, ChineseName: "里弗顿", Name: "RIVERTON" },
  { Id: 5763, ChineseName: "里耶卡", Name: "RIJEKA" },
  { Id: 5765, ChineseName: "罗克兰", Name: "ROCKLAND" },
  { Id: 5768, ChineseName: "罗斯托克", Name: "Rostock" },
  { Id: 5771, ChineseName: "兰帕特", Name: "RAMPART" },
  { Id: 5776, ChineseName: "波荷木岛", Name: "BORNHOLM" },
  { Id: 5784, ChineseName: "赖布尔", Name: "RAIPUR" },
  { Id: 5789, ChineseName: "俄罗斯教区", Name: "RUSSIAN MISSION" },
  { Id: 5791, ChineseName: "罗切斯特", Name: "ROCHESTER" },
  { Id: 5793, ChineseName: "萨拉托夫", Name: "SARATOV" },
  { Id: 5797, ChineseName: "圣丹尼斯", Name: "SAINT DENIS REUNION" },
  { Id: 5799, ChineseName: "拉特兰", Name: "Rutland County" },
  { Id: 5803, ChineseName: "热舒夫", Name: "RZESZOW" },
  { Id: 5806, ChineseName: "圣达菲", Name: "SANTA FE" },
  { Id: 5807, ChineseName: "绍达克卢库", Name: "SAUDARKROKUR" },
  { Id: 5808, ChineseName: "圣萨尔瓦多", Name: "SAN SALVADOR" },
  { Id: 5810, ChineseName: "圣佩德罗苏拉", Name: "SAN PEDRO SULA" },
  { Id: 5818, ChineseName: "死马镇", Name: "PRUDHOE BAY DEADH" },
  { Id: 5820, ChineseName: "斯卡曼门湾", Name: "SCAMMON BAY" },
  { Id: 5821, ChineseName: "萨尔布吕肯", Name: "SAARBRUECKEN" },
  { Id: 5823, ChineseName: "圣地亚哥", Name: "SANTIAGO" },
  { Id: 5833, ChineseName: "沙点市", Name: "SAND POINT" },
  { Id: 5834, ChineseName: "圣多明戈", Name: "Santo Domingo" },
  { Id: 5851, ChineseName: "苏尔古特", Name: "SURGUT" },
  { Id: 5857, ChineseName: "史凯威", Name: "SKAGWAY" },
  { Id: 5860, ChineseName: "斯丹顿", Name: "STAUNTON" },
  { Id: 5862, ChineseName: "术古纳克", Name: "SHUNGNAK" },
  { Id: 5863, ChineseName: "施沙木勒幅", Name: "SHISHMAREF" },
  { Id: 5867, ChineseName: "沙格鲁", Name: "SHAGELUK" },
  { Id: 5872, ChineseName: "夕卡", Name: "SITKA" },
  { Id: 5883, ChineseName: "沙克突利", Name: "SHAKTOOLIK" },
  { Id: 5884, ChineseName: "斯托克马克内斯", Name: "STOKMARKNES" },
  { Id: 5891, ChineseName: "塞拉莱", Name: "SALALAH" },
  { Id: 5894, ChineseName: "圣路易斯波托西", Name: "SAN LUIS POTOSI" },
  { Id: 5895, ChineseName: "斯丽特木德", Name: "SLEETMUTE" },
  { Id: 5900, ChineseName: "圣路易斯", Name: "SAO LUIZ" },
  { Id: 5902, ChineseName: "萨莫斯", Name: "SAMOS" },
  { Id: 5904, ChineseName: "圣迈克尔", Name: "SAINT MICHAEL" },
  { Id: 5907, ChineseName: "圣马尔塔", Name: "SANTA MARTA" },
  { Id: 5909, ChineseName: "圣马丽亚", Name: "SANTA MARIA" },
  { Id: 5912, ChineseName: "圣保罗岛", Name: "SAINT PAUL ISLAND" },
  { Id: 5922, ChineseName: "塞尔多维亚", Name: "SELDOVIA" },
  { Id: 5923, ChineseName: "斯特旺塞", Name: "STRONSAY" },
  { Id: 5933, ChineseName: "苏克雷", Name: "SUCRE" },
  { Id: 5936, ChineseName: "萨拉索塔", Name: "SARASOTA" },
  { Id: 5937, ChineseName: "史东尼河", Name: "STONY RIVER" },
  { Id: 5950, ChineseName: "圣多明戈", Name: "SANTO DOMINGO" },
  { Id: 5952, ChineseName: "圣地亚哥", Name: "SANTIAGO" },
  { Id: 5957, ChineseName: "拉默齐亚", Name: "Lamezia Terme" },
  { Id: 5961, ChineseName: "太阳谷", Name: "HAILEY" },
  { Id: 5964, ChineseName: "苏城", Name: "Sioux City" },
  { Id: 5965, ChineseName: "萨文加", Name: "SAVOONGA" },
  { Id: 5971, ChineseName: "史蒂芬斯威里奇", Name: "STEVENS VILLAGE" },
  { Id: 5974, ChineseName: "纽堡", Name: "NEWBURGH" },
  { Id: 5984, ChineseName: "谢尔登波因特", Name: "SHELDON POINT" },
  { Id: 5988, ChineseName: "斯托诺韦", Name: "STORNOWAY" },
  { Id: 5995, ChineseName: "塔比拉兰", Name: "Tagbilaran" },
  { Id: 6000, ChineseName: "塔那那", Name: "TANANA" },
  { Id: 6001, ChineseName: "坦皮科", Name: "TAMPICO" },
  { Id: 6019, ChineseName: "塔克特纳", Name: "TAKOTNA" },
  { Id: 6023, ChineseName: "桐艾府", Name: "TRAT" },
  { Id: 6024, ChineseName: "泰德包罗", Name: "TETERBORO" },
  { Id: 6030, ChineseName: "特柳莱德", Name: "TELLURIDE" },
  { Id: 6032, ChineseName: "特费", Name: "TEFE" },
  {
    Id: 6039,
    ChineseName: "图斯特拉-古铁雷斯",
    Name: "TUXTLA GUTIERREZ",
  },
  { Id: 6040, ChineseName: "特雷西纳", Name: "TERESINA" },
  { Id: 6057, ChineseName: "蒂瓦特", Name: "TIVAT" },
  { Id: 6069, ChineseName: "括克", Name: "TOK" },
  { Id: 6074, ChineseName: "泰勒", Name: "TELLER" },
  { Id: 6079, ChineseName: "图鲁克萨克", Name: "TULUKSAK" },
  { Id: 6096, ChineseName: "图努纳克", Name: "TUNUNAK" },
  { Id: 6102, ChineseName: "托木斯克", Name: "TOMSK" },
  { Id: 6103, ChineseName: "托盖克", Name: "Togiak" },
  {
    Id: 6116,
    ChineseName: "泰里岛 因纳赫布里德斯",
    Name: "TIREE INNER HEBRIDES",
  },
  { Id: 6117, ChineseName: "陶朗阿加", Name: "TAURANGA" },
  { Id: 6118, ChineseName: "布里斯托尔", Name: "Bristol" },
  { Id: 6124, ChineseName: "陶斯", Name: "TAOS" },
  { Id: 6141, ChineseName: "小偷河瀑布市", Name: "Thief River Falls" },
  { Id: 6147, ChineseName: "特温福尔斯", Name: "Twin Falls" },
  { Id: 6150, ChineseName: "泰勒", Name: "TYLER" },
  { Id: 6157, ChineseName: "乌贝拉巴", Name: "UBERABA" },
  { Id: 6165, ChineseName: "乌代布尔", Name: "UDAIPUR" },
  {
    Id: 6178,
    ChineseName: "乌斯季卡缅诺戈尔斯克",
    Name: "UST KAMENOGORSK",
  },
  { Id: 6188, ChineseName: "于默奥", Name: "UMEA" },
  { Id: 6193, ChineseName: "乌纳拉克里", Name: "UNALAKLEET" },
  { Id: 6194, ChineseName: "拉廊", Name: "RANONG" },
  { Id: 6204, ChineseName: "布山加", Name: "BUSUANGA" },
  { Id: 6210, ChineseName: "乌兰乌德", Name: "Ulan-Ude" },
  { Id: 6222, ChineseName: "维斯堡", Name: "VISBY" },
  { Id: 6223, ChineseName: "维多利亚", Name: "VICTORIA" },
  { Id: 6228, ChineseName: "瓦代兹", Name: "VALDEZ" },
  { Id: 6229, ChineseName: "威尼泰", Name: "VENETIE" },
  { Id: 6232, ChineseName: "韦拉克鲁斯", Name: "VERACRUZ" },
  { Id: 6233, ChineseName: "维多利亚大瀑布", Name: "Victoria Falls" },
  { Id: 6237, ChineseName: "荣市", Name: "VINH CITY" },
  { Id: 6240, ChineseName: "维塞利亚", Name: "VISALIA" },
  { Id: 6241, ChineseName: "维托里亚", Name: "VITORIA" },
  { Id: 6243, ChineseName: "维多利亚", Name: "VITORIA" },
  { Id: 6246, ChineseName: "弗多斯塔", Name: "VALDOSTA" },
  { Id: 6259, ChineseName: "瓦拉德", Name: "VARADERO" },
  { Id: 6273, ChineseName: "韦克舍", Name: "VAXJO" },
  { Id: 6274, ChineseName: "威尔士", Name: "WALES" },
  { Id: 6281, ChineseName: "阿拉斯加特宾斯", Name: "Stebbins" },
  { Id: 6282, ChineseName: "比弗", Name: "Beaver" },
  { Id: 6298, ChineseName: "阿勒纳季克", Name: "Aleknagik" },
  { Id: 6300, ChineseName: "阿拉斯加萨拉维克", Name: "Selawik" },
  { Id: 6304, ChineseName: "白山", Name: "White Mountain" },
  { Id: 6310, ChineseName: "旺阿雷", Name: "WHANGAREI" },
  { Id: 6311, ChineseName: "兰格尔", Name: "Wrangell" },
  { Id: 6313, ChineseName: "韦斯特雷", Name: "Westray" },
  { Id: 6314, ChineseName: "南纳克内克", Name: "South Naknek" },
  { Id: 6318, ChineseName: "西港", Name: "Westport" },
  { Id: 6322, ChineseName: "通图图里阿克", Name: "TUNTUTULIAK" },
  { Id: 6333, ChineseName: "钮特克", Name: "Newtok" },
  { Id: 6359, ChineseName: "图芬诺", Name: "Tofino" },
  { Id: 6360, ChineseName: "坎贝尔河", Name: "Campbell River" },
  { Id: 6363, ChineseName: "道森", Name: "DAWSON CITY" },
  { Id: 6373, ChineseName: "伊努维克", Name: "Inuvik" },
  { Id: 6386, ChineseName: "各沃斯奈罗", Name: "Gods Narrows" },
  { Id: 6393, ChineseName: "柴登", Name: "Dryden" },
  { Id: 6407, ChineseName: "雅吉瓦", Name: "Yakima" },
  { Id: 6428, ChineseName: "贝斯比利湖", Name: "North Spirit Lake" },
  { Id: 6430, ChineseName: "襄阳", Name: "YANGYANG" },
  { Id: 6431, ChineseName: "老乌鸦", Name: "Old Crow" },
  { Id: 6433, ChineseName: "牛津屋", Name: "Oxford House" },
  { Id: 6438, ChineseName: "保拉图克", Name: "Paulatuk" },
  { Id: 6444, ChineseName: "皮沃那克", Name: "Peawanuck" },
  { Id: 6445, ChineseName: "鲁伯特王子市", Name: "Prince Rupert" },
  { Id: 6447, ChineseName: "鲍威尔河", Name: "Powell River" },
  { Id: 6453, ChineseName: "凯诺拉", Name: "Kenora" },
  { Id: 6456, ChineseName: "康英克斯", Name: "Comox" },
  { Id: 6465, ChineseName: "红湖", Name: "Red Lake" },
  { Id: 6477, ChineseName: "多塞特角", Name: "Cape Dorset" },
  { Id: 6487, ChineseName: "尤马", Name: "Yuma" },
  { Id: 6497, ChineseName: "诺曼韦尔斯", Name: "Norman Wells" },
  { Id: 6498, ChineseName: "鹿湖", Name: "Deer Lake" },
  { Id: 6502, ChineseName: "威廉斯莱克", Name: "Williams Lake" },
  { Id: 6507, ChineseName: "斯沃鲁克奥", Name: "Sioux Lookout" },
  { Id: 6511, ChineseName: "德瑞司", Name: "Terrace" },
  { Id: 6512, ChineseName: "阿博茨福德", Name: "Abbotsford" },
  { Id: 6513, ChineseName: "怀特霍斯", Name: "Whitehorse" },
  { Id: 6515, ChineseName: "使密得斯", Name: "Smithers" },
  { Id: 6517, ChineseName: "潘提顿", Name: "Penticton" },
  { Id: 6526, ChineseName: "松妮亚", Name: "Sarnia" },
  { Id: 6528, ChineseName: "哈迪港", Name: "Port Hardy" },
  { Id: 6531, ChineseName: "扎达尔", Name: "Zadar" },
  { Id: 6533, ChineseName: "瓦尔迪维亚", Name: "Valdivia" },
  { Id: 6541, ChineseName: "特木科", Name: "Temuco" },
  { Id: 6542, ChineseName: "贝拉贝拉", Name: "Bella Bella" },
  { Id: 6562, ChineseName: "圣皮埃尔", Name: "Saint Pierre" },
  { Id: 6563, ChineseName: "桑迪莱克", Name: "SANDY LAKE" },
  { Id: 6565, ChineseName: "扎金索斯", Name: "Zakinthos Island" },
  { Id: 6568, ChineseName: "沙湾拿吉", Name: "Savannakhet" },
  { Id: 6570, ChineseName: "锡尔赫特", Name: "SYLHET" },
  { Id: 6575, ChineseName: "安纳巴", Name: "Annaba" },
  { Id: 6582, ChineseName: "艾因", Name: "Al Ain" },
  { Id: 6584, ChineseName: "阿那帕", Name: "Anapa" },
  { Id: 6599, ChineseName: "安布勒", Name: "AMBLER" },
  { Id: 6615, ChineseName: "阿里卡", Name: "ARICA" },
  { Id: 6620, ChineseName: "韦科", Name: "WACO" },
  { Id: 6622, ChineseName: "阿克塔", Name: "ARCATA" },
  { Id: 6634, ChineseName: "科迪亚克", Name: "KODIAK" },
  { Id: 6649, ChineseName: "奥勒松", Name: "Alesund" },
  { Id: 6650, ChineseName: "阿拉卡基特", Name: "ALLAKAKET" },
  { Id: 6653, ChineseName: "阿克雷里", Name: "AKUREYRI" },
  { Id: 6673, ChineseName: "阿瓜斯卡连特斯", Name: "AGUASCALIENTES" },
  { Id: 6708, ChineseName: "埃斯卡纳巴", Name: "ESCANABA" },
  { Id: 6709, ChineseName: "东松德", Name: "EASTSOUND" },
  { Id: 6710, ChineseName: "萨尔瓦多", Name: "EL SALVADOR" },
  { Id: 6711, ChineseName: "索维拉", Name: "ESSAOUIRA" },
  { Id: 6718, ChineseName: "新贝德福德", Name: "NEW BEDFORD" },
  { Id: 6721, ChineseName: "埃克塞特", Name: "EXETER" },
  { Id: 6726, ChineseName: "弗雷斯诺", Name: "FRESNO" },
  { Id: 6740, ChineseName: "卡尔斯鲁厄", Name: "KARLSRUHE" },
  { Id: 6741, ChineseName: "富兰克林", Name: "FRANKLIN" },
  { Id: 6743, ChineseName: "弗卢里亚诺波利斯", Name: "FLORIANOPOLIS" },
  { Id: 6750, ChineseName: "弗林特", Name: "FLINT" },
  { Id: 6754, ChineseName: "弗里波特", Name: "FREEPORT" },
  { Id: 6756, ChineseName: "星期五港", Name: "FRIDAY HARBOR" },
  { Id: 6759, ChineseName: "弗卢勒", Name: "FLORO" },
  { Id: 6762, ChineseName: "菲加里.科西嘉", Name: "FIGARI" },
  { Id: 6763, ChineseName: "苏福尔斯", Name: "SIOUX FALLS" },
  { Id: 6764, ChineseName: "史密斯堡", Name: "FORT SMITH" },
  { Id: 6767, ChineseName: "埃尔卡拉法特", Name: "EL CALAFATE" },
  { Id: 6774, ChineseName: "育空堡", Name: "FORT YUKON" },
  { Id: 6777, ChineseName: "加利纳", Name: "GALENA" },
  { Id: 6778, ChineseName: "甘伯尔", Name: "GAMBELL" },
  { Id: 6781, ChineseName: "古瓦哈蒂", Name: "GUWAHATI" },
  { Id: 6787, ChineseName: "吉勒台", Name: "Gillette" },
  { Id: 6788, ChineseName: "加登城", Name: "GARDEN CITY" },
  { Id: 6789, ChineseName: "大开曼岛", Name: "Grand Cayman" },
  { Id: 6795, ChineseName: "基联恩金克", Name: "Gelendzhik" },
  { Id: 6803, ChineseName: "大福克斯", Name: "GRAND FORKS" },
  { Id: 6804, ChineseName: "格拉夫顿", Name: "GRAFTON" },
  { Id: 6813, ChineseName: "直布罗陀", Name: "GIBRALTAR" },
  { Id: 6820, ChineseName: "大章克申", Name: "GRAND JUNCTION" },
  { Id: 6827, ChineseName: "戈络文", Name: "GOLOVIN" },
  { Id: 6834, ChineseName: "古德纽斯湾", Name: "GOODNEWS BAY" },
  { Id: 6846, ChineseName: "格林贝", Name: "GREEN BAY" },
  { Id: 6848, ChineseName: "格罗宁根", Name: "GRONINGEN" },
  { Id: 6852, ChineseName: "古斯塔夫斯", Name: "GUSTAVUS" },
  { Id: 6857, ChineseName: "盖洛普", Name: "GALLUP" },
  { Id: 6868, ChineseName: "戈亚尼亚", Name: "GOIANIA" },
  { Id: 6875, ChineseName: "哈尔姆斯塔德", Name: "HALMSTAD" },
  { Id: 6880, ChineseName: "海于格生德", Name: "HAUGESUND" },
  { Id: 6883, ChineseName: "霍利克罗斯", Name: "HOLY CROSS" },
  { Id: 6890, ChineseName: "赫拉克利翁", Name: "HERAKLION" },
  { Id: 6894, ChineseName: "哈默弗斯特", Name: "HAMMERFEST" },
  { Id: 6900, ChineseName: "黑格斯敦", Name: "HAGERSTOWN" },
  { Id: 6904, ChineseName: "西宾", Name: "HIBBING" },
  { Id: 6906, ChineseName: "哈瓦苏湖城", Name: "Lake Havasu City" },
  { Id: 6913, ChineseName: "希利赖克", Name: "HEALY LAKE" },
  { Id: 6920, ChineseName: "汉密尔顿", Name: "HAMILTON" },
  { Id: 6921, ChineseName: "马尔默", Name: "Khanty Mansiysk" },
  { Id: 6923, ChineseName: "埃莫西约", Name: "HERMOSILLO" },
  { Id: 6926, ChineseName: "胡纳", Name: "HOONAH" },
  { Id: 6928, ChineseName: "哈伊尼斯", Name: "HAINES" },
  { Id: 6929, ChineseName: "霍布斯", Name: "HOBBS" },
  { Id: 6933, ChineseName: "奥尔金", Name: "HOLGUIN" },
  { Id: 6935, ChineseName: "荷马", Name: "HOMER" },
  { Id: 6941, ChineseName: "胡珀湾", Name: "Hooper Bay" },
  { Id: 6942, ChineseName: "海防", Name: "HAIPHONG" },
  { Id: 6944, ChineseName: "哈灵根", Name: "HARLINGEN" },
  { Id: 6954, ChineseName: "花莲", Name: "HUALIEN" },
  { Id: 6956, ChineseName: "休斯", Name: "HUGHES" },
  { Id: 6962, ChineseName: "纽黑文", Name: "NEW HAVEN" },
  { Id: 6964, ChineseName: "海恩尼斯", Name: "HYANNIS" },
  { Id: 6971, ChineseName: "凯厄纳", Name: "KIANA" },
  { Id: 6973, ChineseName: "雅罗斯拉夫", Name: "YAROSLAVL" },
  { Id: 6975, ChineseName: "伊巴丹", Name: "IBADAN" },
  { Id: 6979, ChineseName: "印多尔", Name: "INDORE" },
  { Id: 6984, ChineseName: "布尔黑特市", Name: "BULLHEAD CITY" },
  { Id: 6986, ChineseName: "伊久吉格", Name: "IGIUGIG" },
  { Id: 6987, ChineseName: "金曼", Name: "KINGMAN" },
  { Id: 6996, ChineseName: "伊利亚姆纳", Name: "ILIAMNA" },
  { Id: 6998, ChineseName: "伊洛伊洛", Name: "ILOILO" },
  { Id: 7000, ChineseName: "艾莱", Name: "ISLAY" },
  { Id: 7011, ChineseName: "伊利乌斯", Name: "ILHEUS" },
  { Id: 7013, ChineseName: "复活节岛", Name: "EASTER ISLAND" },
  { Id: 7017, ChineseName: "威廉斯波特", Name: "WILLIAMSPORT" },
  { Id: 7024, ChineseName: "柯克斯维尔", Name: "KIRKSVILLE" },
  { Id: 7029, ChineseName: "艾斯利普", Name: "ISLIP" },
  { Id: 7031, ChineseName: "伊萨卡", Name: "ITHACA" },
  { Id: 7035, ChineseName: "因佛卡吉尔", Name: "INVERCARGILL" },
  { Id: 7037, ChineseName: "艾恩伍德", Name: "IRONWOOD" },
  { Id: 7042, ChineseName: "门格洛尔", Name: "MANGALORE" },
  { Id: 7046, ChineseName: "马杜赖", Name: "MADURAI" },
  { Id: 7047, ChineseName: "兰契", Name: "RANCHI" },
  { Id: 7049, ChineseName: "奥兰加巴德", Name: "AURANGABAD" },
  { Id: 7051, ChineseName: "因约肯", Name: "INYOKERN" },
  { Id: 7059, ChineseName: "琼斯伯勒", Name: "JONESBORO" },
  { Id: 7085, ChineseName: "希俄斯", Name: "CHIOS" },
  { Id: 7092, ChineseName: "朱诺", Name: "JUNEAU" },
  { Id: 7094, ChineseName: "儒万维尔", Name: "JOINVILLE" },
  { Id: 7104, ChineseName: "斯基亚索斯", Name: "SKIATHOS" },
  { Id: 7105, ChineseName: "杰索尔", Name: "JESSORE" },
  { Id: 7108, ChineseName: "锡罗斯岛", Name: "SYROS ISLAND" },
  { Id: 7123, ChineseName: "卡尔塔格", Name: "KALTAG" },
  { Id: 7126, ChineseName: "伯奇克里克", Name: "BIRCH CREEK" },
  { Id: 7132, ChineseName: "奇格尼克", Name: "CHIGNIK" },
  { Id: 7142, ChineseName: "埃阔克", Name: "EKWOK" },
  { Id: 7149, ChineseName: "福尔斯帕斯", Name: "FALSE PASS" },
  { Id: 7159, ChineseName: "科斯", Name: "KOS" },
  { Id: 7160, ChineseName: "格雷林", Name: "GRAYLING" },
  { Id: 7180, ChineseName: "科尤克", Name: "KOYUK" },
  { Id: 7182, ChineseName: "凯里凯里", Name: "KERIKERI" },
  { Id: 7183, ChineseName: "孔基加纳克", Name: "KONGIGANAK" },
  { Id: 7184, ChineseName: "阿基亚查克", Name: "AKIACHAK" },
  { Id: 7185, ChineseName: "希尔克内斯", Name: "KIRKENES" },
  { Id: 7191, ChineseName: "卡尔斯卡格", Name: "KALSKAG" },
  { Id: 7192, ChineseName: "莱弗洛克", Name: "LEVELOCK" },
  { Id: 7195, ChineseName: "卡拉马塔", Name: "KALAMATA" },
  { Id: 7201, ChineseName: "马诺科塔克", Name: "MANOKOTAK" },
  { Id: 7204, ChineseName: "卡克霍纳克", Name: "KAKHONAK" },
  { Id: 7207, ChineseName: "新斯图亚霍克", Name: "NEW STUYAHOK" },
  { Id: 7211, ChineseName: "柯克沃尔", Name: "KIRKWALL" },
  { Id: 7212, ChineseName: "佛统", Name: "Nakorn Pathom" },
  { Id: 7218, ChineseName: "基普努克", Name: "KIPUNK" },
  { Id: 7220, ChineseName: "佩里维尔", Name: "PERRYVILLE" },
  { Id: 7225, ChineseName: "基律纳", Name: "KIRUNA" },
  { Id: 7232, ChineseName: "圣马丽斯", Name: "SAINT MARYS" },
  { Id: 7234, ChineseName: "卡斯托里亚", Name: "KASTORIA" },
  { Id: 7236, ChineseName: "克里斯蒂安松", Name: "KRISTIANSUND" },
  { Id: 7244, ChineseName: "凯奇坎", Name: "KETCHIKAN" },
  {
    Id: 7246,
    ChineseName: "布雷维格（泰勒）传教区",
    Name: "TELLER MISSION",
  },
  { Id: 7249, ChineseName: "阿尔缪特", Name: "KASIGLUK" },
  { Id: 7251, ChineseName: "考纳斯", Name: "KAUNAS" },
  { Id: 7256, ChineseName: "卡瓦拉", Name: "KAVALA" },
  { Id: 7258, ChineseName: "金科夫", Name: "KING COVE" },
  { Id: 7262, ChineseName: "基瓦利纳", Name: "KIVALINA" },
  { Id: 7266, ChineseName: "奎吉林戈克", Name: "KWIGILLINGOK" },
  { Id: 7268, ChineseName: "昆哈加克", Name: "QUINHAGAK" },
  { Id: 7270, ChineseName: "奎斯芦克", Name: "KWETHLUK" },
  { Id: 7272, ChineseName: "卡萨", Name: "KASAAN" },
  { Id: 7275, ChineseName: "科尤库克", Name: "KOYUKUK" },
  { Id: 7278, ChineseName: "科扎尼", Name: "KOZANI" },
  { Id: 7288, ChineseName: "拉伯克", Name: "LUBBOCK" },
  { Id: 7289, ChineseName: "拉特罗布", Name: "LATROBE" },
  { Id: 7290, ChineseName: "北普拉特", Name: "NORTH PLATTE" },
  { Id: 7292, ChineseName: "利伯勒尔", Name: "LIBERAL" },
  { Id: 7299, ChineseName: "罗兹", Name: "LODZ" },
  { Id: 7320, ChineseName: "莱加斯皮", Name: "LEGASPI" },
  { Id: 7328, ChineseName: "利韦里亚", Name: "LIBERIA" },
  { Id: 7334, ChineseName: "勒克瑙", Name: "LUCKNOW" },
  { Id: 7335, ChineseName: "吕勒奥", Name: "LULEA" },
  { Id: 7338, ChineseName: "莱克明丘米纳", Name: "LAKE MINCHUMINA" },
  { Id: 7348, ChineseName: "兰卡斯特", Name: "LANCASTER" },
  { Id: 7350, ChineseName: "拉奈", Name: "LANAI CITY" },
  { Id: 7362, ChineseName: "拉雷多", Name: "LAREDO" },
  { Id: 7365, ChineseName: "拉罗马纳", Name: "LA ROMANA" },
  { Id: 7369, ChineseName: "拉塞雷纳", Name: "LA SERENA" },
  { Id: 7383, ChineseName: "劳莱尔", Name: "Laurel" },
  { Id: 7388, ChineseName: "利文斯通", Name: "LIVINGSTONE" },
  { Id: 7397, ChineseName: "林奇堡", Name: "LYNCHBURG" },
  { Id: 7398, ChineseName: "朗伊尔城", Name: "LONGYEARBYEN" },
  { Id: 7422, ChineseName: "默塞德", Name: "MERCED" },
  { Id: 7423, ChineseName: "麦格拉斯", Name: "MCGRATH" },
  { Id: 7424, ChineseName: "麦库克", Name: "MCCOOK" },
  { Id: 7430, ChineseName: "梅森城", Name: "MASON CITY" },
  { Id: 7434, ChineseName: "麦德林", Name: "MEDELLIN" },
  { Id: 7450, ChineseName: "马那瓜", Name: "MANAGUA" },
  { Id: 7452, ChineseName: "马林加", Name: "MARINGA" },
  { Id: 7461, ChineseName: "曼哈顿", Name: "MANHATTAN" },
  { Id: 7469, ChineseName: "莫纳斯提尔", Name: "MONASTIR" },
  { Id: 7505, ChineseName: "基督城", Name: "CHRISTCHURCH" },
  { Id: 7515, ChineseName: "普林塞萨港", Name: "Puerto Princesa" },
  { Id: 7518, ChineseName: "乌兰察布", Name: "Ulanqab" },
  { Id: 7531, ChineseName: "大新", Name: "Daxinxian" },
  { Id: 7533, ChineseName: "平阳", Name: "pingyang" },
  { Id: 7534, ChineseName: "昌吉市", Name: "changji" },
  { Id: 7536, ChineseName: "平邑", Name: "pingyi" },
  { Id: 7537, ChineseName: "凉山", Name: "liangshanzhou" },
  { Id: 7540, ChineseName: "马尔康", Name: "Maerkang" },
  { Id: 7543, ChineseName: "费拉格尔斯塔夫", Name: "Flagstaff" },
  { Id: 7545, ChineseName: "林州", Name: "Linzhou" },
  { Id: 7548, ChineseName: "阿拉善", Name: "Alashan" },
  { Id: 7549, ChineseName: "泸定", Name: "Luding" },
  { Id: 7550, ChineseName: "彭州", Name: "Pengzhou" },
  { Id: 7551, ChineseName: "商洛", Name: "Shangluo" },
  { Id: 7557, ChineseName: "如东", Name: "Rudong" },
  { Id: 7559, ChineseName: "海门", Name: "Haimen" },
  { Id: 7571, ChineseName: "磐安", Name: "Panan" },
  { Id: 7576, ChineseName: "锡林郭勒", Name: "Xilinguole" },
  { Id: 7578, ChineseName: "兴化", Name: "Xinghua" },
  { Id: 7582, ChineseName: "玉树县", Name: "yushu" },
  { Id: 7586, ChineseName: "开化", Name: "kaihua" },
  { Id: 7587, ChineseName: "吴忠", Name: "wuzhong" },
  { Id: 7589, ChineseName: "海西", Name: "Haixizhou" },
  { Id: 7590, ChineseName: "常山", Name: "Changshan" },
  { Id: 7612, ChineseName: "第比利斯", Name: "TBILISI" },
  { Id: 7617, ChineseName: "斯科普里", Name: "SKOPJE" },
  { Id: 7619, ChineseName: "仁怀", Name: "Renhuai" },
  { Id: 7624, ChineseName: "四会", Name: "Sihui" },
  { Id: 7625, ChineseName: "广饶", Name: "Guangrao" },
  { Id: 7626, ChineseName: "二连浩特", Name: "Erenhot" },
  { Id: 7631, ChineseName: "吕梁", Name: "Lvliang" },
  { Id: 7637, ChineseName: "栾川", Name: "Luanchuan" },
  { Id: 7638, ChineseName: "额尔古纳", Name: "Eerguna" },
  { Id: 7645, ChineseName: "法恩伯勒", Name: "FARNBOROUGH" },
  { Id: 7652, ChineseName: "凤山", Name: "Fengshan" },
  { Id: 7661, ChineseName: "辛菲罗波尔", Name: "SIMFEROPOL" },
  { Id: 7663, ChineseName: "大兴安岭", Name: "Daxinganling" },
  { Id: 7665, ChineseName: "遂昌", Name: "Suichang" },
  { Id: 7666, ChineseName: "苍南", Name: "Cangnan" },
  { Id: 7668, ChineseName: "马斯特里赫特", Name: "Maastricht" },
  { Id: 7669, ChineseName: "栖霞", Name: "Qixia" },
  { Id: 7674, ChineseName: "长岛", Name: "Changdao" },
  { Id: 7700, ChineseName: "五莲", Name: "Wulianxian" },
  { Id: 7707, ChineseName: "陇南", Name: "Longnan" },
  { Id: 7732, ChineseName: "内夫谢希尔", Name: "NEVSEHIR" },
  { Id: 7736, ChineseName: "安丘", Name: "Anqiu" },
  { Id: 7752, ChineseName: "海东", Name: "Haidong" },
  { Id: 7754, ChineseName: "台拉登", Name: "DEHRA DUN" },
  { Id: 7766, ChineseName: "禹州", Name: "Yuzhou" },
  { Id: 7767, ChineseName: "泗洪", Name: "Sihong" },
  { Id: 7774, ChineseName: "胡萨维克", Name: "Husavik" },
  { Id: 7784, ChineseName: "苏圣玛丽", Name: "SAULT STE.MARIE" },
  { Id: 7792, ChineseName: "五家渠", Name: "Wujiaqu" },
  { Id: 7794, ChineseName: "海南", Name: "Hainan" },
  { Id: 7802, ChineseName: "黄南", Name: "Huangnan" },
  { Id: 7804, ChineseName: "洞海", Name: "DONG HOI" },
  { Id: 7807, ChineseName: "海北", Name: "Haibei" },
  { Id: 7808, ChineseName: "马祖", Name: "Matsu" },
  { Id: 7844, ChineseName: "甘南", Name: "Gannan" },
  { Id: 9211, ChineseName: "佛洛斯", Name: "Volos" },
  { Id: 9416, ChineseName: "布尔加", Name: "Burgas" },
  { Id: 9553, ChineseName: "唐克斯特", Name: "Doncaster" },
  { Id: 9585, ChineseName: "埃斯基谢希尔", Name: "Eskisehir" },
  { Id: 9758, ChineseName: "贾巴尔普尔", Name: "JABALPUR" },
  { Id: 9880, ChineseName: "卢布林", Name: "Lublin" },
  { Id: 9882, ChineseName: "卢迪亚纳", Name: "Ludhiana" },
  { Id: 9986, ChineseName: "迈索尔", Name: "Mysore" },
  { Id: 10070, ChineseName: "帕伦克", Name: "Palenque" },
  { Id: 10257, ChineseName: "贝尔格莱德", Name: "Belgrade" },
  { Id: 10258, ChineseName: "拉各斯", Name: "Lagos" },
  { Id: 10259, ChineseName: "兰卡斯特", Name: "Lancaster" },
  { Id: 10260, ChineseName: "萨拉热沃", Name: "Sarajevo" },
  { Id: 10266, ChineseName: "萨马纳半岛", Name: "Samana" },
  { Id: 19744, ChineseName: "麦地那", Name: "Madinah" },
  { Id: 19847, ChineseName: "罗克福德", Name: "Rockford" },
  { Id: 19894, ChineseName: "普罗沃", Name: "Provo" },
  { Id: 19958, ChineseName: "贵德", Name: "Guide" },
  { Id: 20008, ChineseName: "奥腊涅斯塔德", Name: "Oranjestad" },
  { Id: 20099, ChineseName: "丹佛", Name: "Denver" },
  { Id: 20413, ChineseName: "洛斯卡波斯", Name: "Los Cabos" },
  { Id: 20431, ChineseName: "马萨阿拉姆", Name: "Marsa Alam" },
  { Id: 20640, ChineseName: "托卢卡", Name: "Toluca" },
  { Id: 20676, ChineseName: "维哥", Name: "Vigo" },
  { Id: 20748, ChineseName: "茨城", Name: "IBARAKI" },
  { Id: 20794, ChineseName: "灵武", Name: "Lingwu" },
  { Id: 20836, ChineseName: "澄迈", Name: "chengmai" },
  { Id: 20868, ChineseName: "临高", Name: "lingao" },
  { Id: 20931, ChineseName: "和田", Name: "hetian" },
  { Id: 20943, ChineseName: "阿拉尔", Name: "alaer" },
  { Id: 20963, ChineseName: "文山", Name: "wenshan" },
  { Id: 21009, ChineseName: "新郑", Name: "xinzheng" },
  { Id: 21021, ChineseName: "兴安盟", Name: "xinganmeng" },
  { Id: 21025, ChineseName: "白沙", Name: "baisha" },
  { Id: 21065, ChineseName: "望奎", Name: "wangkui" },
  { Id: 21089, ChineseName: "涞水", Name: "laishui" },
  { Id: 21114, ChineseName: "玉树", Name: "yushu" },
  { Id: 21121, ChineseName: "长海", Name: "changhai" },
  { Id: 21127, ChineseName: "屏南", Name: "pingnan" },
  { Id: 21130, ChineseName: "巴音郭楞", Name: "bayinguoleng" },
  { Id: 21179, ChineseName: "黔南", Name: "qiannan" },
  { Id: 21269, ChineseName: "阿拉善左旗", Name: "alashanzuoqi" },
  { Id: 21339, ChineseName: "额济纳旗", Name: "ejinaqi" },
  { Id: 21358, ChineseName: "喀什", Name: "kashi" },
  { Id: 21468, ChineseName: "博尔塔拉", Name: "boertala" },
  { Id: 21482, ChineseName: "克孜勒苏", Name: "kezilesu" },
  { Id: 21551, ChineseName: "新源", Name: "xinyuan" },
  { Id: 21613, ChineseName: "黔西南", Name: "qianxinan" },
  { Id: 21630, ChineseName: "温泉", Name: "wenquan" },
  { Id: 21658, ChineseName: "楚雄", Name: "chuxiong" },
  { Id: 21741, ChineseName: "沧源", Name: "cangyuan" },
  { Id: 21778, ChineseName: "黔东南", Name: "qiandongnan" },
  { Id: 21779, ChineseName: "开封县", Name: "kaifengxian" },
  { Id: 21862, ChineseName: "果洛", Name: "Golog" },
  { Id: 21863, ChineseName: "阿拉善右旗", Name: "alashanyouqi" },
  { Id: 21888, ChineseName: "图木舒克", Name: "tumushuke" },
  { Id: 21943, ChineseName: "抚远", Name: "fuyuan" },
  { Id: 21951, ChineseName: "阿勒泰市", Name: "aletaishi" },
  { Id: 21952, ChineseName: "大竹", Name: "dazhu" },
  { Id: 22031, ChineseName: "毕节", Name: "bijie" },
  { Id: 22042, ChineseName: "阿尔及尔", Name: "Alger" },
  { Id: 22701, ChineseName: "波尔图", Name: "Porto" },
  { Id: 23523, ChineseName: "尼姆", Name: "Nimes" },
  { Id: 24103, ChineseName: "蒙特利尔", Name: "montréal" },
  { Id: 25410, ChineseName: "堪萨斯城", Name: "Kansas City" },
  { Id: 25526, ChineseName: "奥斯汀", Name: "Austin" },
  { Id: 25538, ChineseName: "莫里斯敦", Name: "Morristown" },
  { Id: 25540, ChineseName: "维洛海滩", Name: "Vero Beach" },
  { Id: 25572, ChineseName: "密尔沃基", Name: "Milwaukie" },
  { Id: 25598, ChineseName: "圣奥古斯丁", Name: "Saint Augustine" },
  { Id: 25633, ChineseName: "安大略", Name: "Ontario" },
  { Id: 25635, ChineseName: "维也纳", Name: "Vienna" },
  { Id: 25643, ChineseName: "得梅因", Name: "Des Moines" },
  { Id: 25676, ChineseName: "伯班克", Name: "Burbank" },
  { Id: 25723, ChineseName: "罗阿诺克", Name: "Roanoke" },
  { Id: 25773, ChineseName: "迈阿密", Name: "Miami" },
  { Id: 25795, ChineseName: "杰克逊维尔", Name: "Jacksonville" },
  { Id: 25805, ChineseName: "诺福克", Name: "Norfolk" },
  { Id: 25830, ChineseName: "伯明翰", Name: "Birmingham" },
  { Id: 25832, ChineseName: "扬斯敦", Name: "Youngstown" },
  { Id: 25858, ChineseName: "波特兰", Name: "Portland" },
  { Id: 25862, ChineseName: "圣克劳德", Name: "Saint Cloud" },
  { Id: 25863, ChineseName: "堪萨斯城", Name: "Kansas City" },
  { Id: 25916, ChineseName: "长滩", Name: "Long Beach" },
  { Id: 25936, ChineseName: "柏林", Name: "Berlin" },
  { Id: 25938, ChineseName: "凤凰城", Name: "Phoenix" },
  {
    Id: 25939,
    ChineseName: "温哥华",
    Name: "Vancouver(Washington State US)",
  },
  { Id: 26033, ChineseName: "列克星敦", Name: "Lexington" },
  { Id: 26066, ChineseName: "庞蒂亚克", Name: "Pontiac" },
  { Id: 26142, ChineseName: "斯特拉斯堡", Name: "Strasburg" },
  { Id: 26153, ChineseName: "费城", Name: "Philadelphia" },
  { Id: 26212, ChineseName: "布里斯班", Name: "Brisbane(California US)" },
  { Id: 26225, ChineseName: "奥格登", Name: "Ogden" },
  { Id: 26282, ChineseName: "拉斯维加斯", Name: "Las Vegas" },
  { Id: 26355, ChineseName: "威尼斯", Name: "Venice" },
  {
    Id: 26363,
    ChineseName: "华盛顿",
    Name: "Washington(District of Columbia US)",
  },
  { Id: 26381, ChineseName: "琼斯伯勒", Name: "Jonesboro" },
  { Id: 26412, ChineseName: "瓦伦西亚", Name: "Valencia" },
  { Id: 26438, ChineseName: "尼亚加拉瀑布", Name: "Niagara Falls" },
  { Id: 26474, ChineseName: "奥尔巴尼", Name: "Albany" },
  { Id: 26475, ChineseName: "伍斯特", Name: "Wooster" },
  { Id: 26479, ChineseName: "博蒙特", Name: "Beaumont" },
  { Id: 26493, ChineseName: "伯明翰", Name: "Birmingham" },
  { Id: 26523, ChineseName: "皮奥里亚", Name: "Peoria" },
  { Id: 26528, ChineseName: "里士满", Name: "Richmond" },
  { Id: 26561, ChineseName: "肖罗", Name: "Show Low" },
  { Id: 26571, ChineseName: "布法罗", Name: "Buffalo" },
  { Id: 26592, ChineseName: "安大略", Name: "Ontario" },
  { Id: 26619, ChineseName: "休斯顿", Name: "Houston" },
  { Id: 26649, ChineseName: "伯班克", Name: "Burbank" },
  {
    Id: 26668,
    ChineseName: "阿姆斯特丹",
    Name: "Amsterdam(New York State US)",
  },
  { Id: 26678, ChineseName: "苏圣玛丽", Name: "Sault Ste. Marie" },
  { Id: 26691, ChineseName: "蓬塔戈尔达", Name: "Punta Gorda" },
  { Id: 26719, ChineseName: "阿伯丁", Name: "Aberdeen" },
  { Id: 26743, ChineseName: "梅德福", Name: "Medford" },
  { Id: 26767, ChineseName: "汉堡", Name: "Hamburg" },
  { Id: 26848, ChineseName: "波士顿", Name: "Boston" },
  { Id: 26852, ChineseName: "夏洛特", Name: "Charlotte" },
  { Id: 26932, ChineseName: "奥尔巴尼", Name: "Albany" },
  { Id: 26934, ChineseName: "凤凰城", Name: "Phenix City" },
  { Id: 26945, ChineseName: "达尼丁", Name: "Dunedin" },
  { Id: 26959, ChineseName: "康科德", Name: "Concord" },
  { Id: 27002, ChineseName: "爱丁堡", Name: "Edinburg" },
  { Id: 27013, ChineseName: "格兰茨帕斯", Name: "Grants Pass" },
  { Id: 27025, ChineseName: "雅典", Name: "Athens" },
  { Id: 27028, ChineseName: "斯托克顿", Name: "Stockton" },
  { Id: 27072, ChineseName: "亚特兰大", Name: "Atlanta" },
  { Id: 27096, ChineseName: "雷德蒙德", Name: "Redmond" },
  { Id: 27105, ChineseName: "那不勒斯", Name: "Naples" },
  { Id: 28716, ChineseName: "哈里森", Name: "Harrison" },
  { Id: 28736, ChineseName: "马斯尔肖尔斯", Name: "Muscle Shoals" },
  { Id: 28751, ChineseName: "莫斯科", Name: "Moscow(Idaho US)" },
  { Id: 28754, ChineseName: "锡达拉皮兹", Name: "Cedar Rapids" },
  { Id: 28824, ChineseName: "摩根敦", Name: "Morgantown" },
  { Id: 28828, ChineseName: "雷丁", Name: "Reading" },
  { Id: 28849, ChineseName: "克里夫兰", Name: "Cleveland" },
  { Id: 28945, ChineseName: "劳顿", Name: "Lawton" },
  { Id: 28955, ChineseName: "萨凡纳", Name: "Savanna" },
  { Id: 28956, ChineseName: "斯蒂尔沃特", Name: "Stillwater" },
  { Id: 28965, ChineseName: "克拉马斯福尔斯", Name: "Klamath Falls" },
  { Id: 29054, ChineseName: "普尔曼", Name: "Pullman" },
  { Id: 29073, ChineseName: "哥伦比亚", Name: "Columbia" },
  { Id: 29086, ChineseName: "因皮里尔", Name: "Imperial" },
  { Id: 29127, ChineseName: "道奇城", Name: "Dodge City" },
  { Id: 29134, ChineseName: "萨莱纳", Name: "Salina" },
  { Id: 29137, ChineseName: "里斯本", Name: "Lisbon" },
  { Id: 29146, ChineseName: "阿拉莫萨", Name: "Alamosa" },
  { Id: 29148, ChineseName: "科特斯", Name: "Cortez" },
  { Id: 29172, ChineseName: "格拉斯哥", Name: "Glasgow" },
  { Id: 29182, ChineseName: "欧文斯伯勒", Name: "Owensboro" },
  { Id: 29238, ChineseName: "普罗温斯敦", Name: "Provincetown" },
  { Id: 29257, ChineseName: "佩里维尔", Name: "Perryville" },
  { Id: 29290, ChineseName: "马尼斯蒂", Name: "Manistee" },
  { Id: 29312, ChineseName: "布雷纳德", Name: "Brainerd" },
  { Id: 29400, ChineseName: "代顿", Name: "Dayton" },
  { Id: 29421, ChineseName: "伊格尔里弗", Name: "Eagle River" },
  { Id: 29441, ChineseName: "贝克利", Name: "Beckley" },
  { Id: 29469, ChineseName: "阿拉莫戈多", Name: "Alamogordo" },
  { Id: 29470, ChineseName: "克洛维斯", Name: "Clovis" },
  { Id: 29479, ChineseName: "银城", Name: "Silver City" },
  { Id: 29501, ChineseName: "迈阿密", Name: "Miami" },
  { Id: 29517, ChineseName: "日内瓦", Name: "Geneva(Illinois US)" },
  { Id: 29542, ChineseName: "亨廷顿", Name: "Huntington" },
  { Id: 29555, ChineseName: "华沙", Name: "Warsaw(Indiana US)" },
  { Id: 29560, ChineseName: "普罗维登斯", Name: "Providence" },
  { Id: 30844, ChineseName: "里尔", Name: "Leer" },
  { Id: 31000, ChineseName: "梅明根", Name: "Memmingen" },
  { Id: 31043, ChineseName: "蒙斯特", Name: "Munster" },
  { Id: 31071, ChineseName: "拿骚", Name: "Nassau" },
  { Id: 31120, ChineseName: "纽伦堡", Name: "Nürnberg" },
  { Id: 32159, ChineseName: "都灵", Name: "Torino" },
  { Id: 32160, ChineseName: "都灵", Name: "Turi" },
  { Id: 32619, ChineseName: "科米索", Name: "Comiso" },
  { Id: 34043, ChineseName: "班夫", Name: "Banff" },
  { Id: 34109, ChineseName: "波士顿", Name: "boston(UK)" },
  { Id: 34227, ChineseName: "达尔文", Name: "darwen(UK)" },
  { Id: 34245, ChineseName: "大峡谷", Name: "Great Glen" },
  { Id: 34328, ChineseName: "弗林特", Name: "Flint" },
  { Id: 34493, ChineseName: "基林", Name: "Killin" },
  { Id: 34784, ChineseName: "罗斯韦尔", Name: "Rothwell" },
  { Id: 34870, ChineseName: "莫尔德", Name: "Mold" },
  { Id: 34880, ChineseName: "墨尔本", Name: "melbourne" },
  { Id: 35345, ChineseName: "伊利", Name: "Ely" },
  { Id: 35474, ChineseName: "纽黑文", Name: "Newhaven" },
  { Id: 35619, ChineseName: "珀斯", Name: "perth(Canada)" },
  { Id: 35679, ChineseName: "威克", Name: "Wick" },
  { Id: 36242, ChineseName: "沙姆沙伊赫", Name: "Sharm El Sheikh" },
  { Id: 36282, ChineseName: "鲸湾港", Name: "Walvis Bay" },
  { Id: 36324, ChineseName: "米德兰", Name: "Midrand" },
  { Id: 36409, ChineseName: "乔治城", Name: "George Town" },
  {
    Id: 36426,
    ChineseName: "阿卡普尔科德华雷斯",
    Name: "Acapulco de Juárez",
  },
  { Id: 36563, ChineseName: "大坎普", Name: "Campo Grande" },
  { Id: 36570, ChineseName: "格兰德岛", Name: "Ilha Grande" },
  { Id: 36599, ChineseName: "若昂佩索阿", Name: "Joao Pessoa" },
  { Id: 36649, ChineseName: "地拉那", Name: "Tirana" },
  { Id: 36663, ChineseName: "巴尔的摩", Name: "Baltimore" },
  { Id: 38001, ChineseName: "腓特烈港", Name: "Frederikshavn" },
  { Id: 38977, ChineseName: "克莱佩达", Name: "Klaipeda" },
  { Id: 39111, ChineseName: "拉巴特", Name: "Rabat" },
  { Id: 39222, ChineseName: "桑内舍恩", Name: "Sandnessjoen" },
  { Id: 39243, ChineseName: "瓦德瑟", Name: "Vadso" },
  { Id: 39526, ChineseName: "奥胡斯", Name: "Ahus" },
  { Id: 39715, ChineseName: "谢莱夫特奥", Name: "Skelleftea" },
  { Id: 39927, ChineseName: "海登", Name: "Heiden" },
  { Id: 40131, ChineseName: "普拉", Name: "Pura" },
  { Id: 40213, ChineseName: "塔尔", Name: "Thal" },
  { Id: 40316, ChineseName: "拉纳卡", Name: "Larnaca" },
  { Id: 40741, ChineseName: "安提瓜", Name: "Costa de Antigua" },
  { Id: 40782, ChineseName: "巴尔韦德", Name: "Valverde" },
  { Id: 40795, ChineseName: "巴塞罗那", Name: "Barcelona(Spain)" },
  { Id: 40933, ChineseName: "德里奥", Name: "Derio" },
  { Id: 40944, ChineseName: "杜兰戈", Name: "Durango" },
  {
    Id: 41132,
    ChineseName: "卡斯特利翁-德拉普拉纳",
    Name: "Castellon de la Plana",
  },
  { Id: 41136, ChineseName: "卡塔赫纳", Name: "Cartagena" },
  { Id: 41253, ChineseName: "拉科鲁尼亚", Name: "La Coruna" },
  { Id: 41255, ChineseName: "拉克鲁斯", Name: "Puerto de la Cruz" },
  { Id: 41261, ChineseName: "拉罗马纳", Name: "La Romana" },
  { Id: 41438, ChineseName: "梅里达", Name: "Mérida" },
  { Id: 41712, ChineseName: "圣巴巴拉", Name: "Santa Bárbara" },
  { Id: 41718, ChineseName: "圣达菲", Name: "Santa Fe" },
  {
    Id: 41720,
    ChineseName: "圣地亚哥德孔波斯特拉",
    Name: "Santiago de Compostela",
  },
  {
    Id: 41746,
    ChineseName: "圣克鲁斯-德拉帕尔马",
    Name: "Santa Cruz de la Palma",
  },
  { Id: 42220, ChineseName: "孔蒂亚斯", Name: "Kondiás" },
  { Id: 42294, ChineseName: "米科诺斯", Name: "Mykonos" },
  { Id: 42666, ChineseName: "阿比林", Name: "Abilene" },
  { Id: 42686, ChineseName: "阿尔塔", Name: "Alta" },
  { Id: 42719, ChineseName: "阿什维尔", Name: "Ashville" },
  { Id: 42723, ChineseName: "亚特兰大", Name: "Atlanta" },
  { Id: 42742, ChineseName: "巴里", Name: "Barre" },
  { Id: 42756, ChineseName: "比弗", Name: "Beaver" },
  { Id: 42761, ChineseName: "贝尔格莱德", Name: "Belgrade" },
  { Id: 42826, ChineseName: "不来梅", Name: "Bremen" },
  { Id: 42849, ChineseName: "布朗斯维尔", Name: "Brownsville" },
  { Id: 42857, ChineseName: "布法罗", Name: "Buffalo" },
  { Id: 42898, ChineseName: "卡尔斯巴德", Name: "Carlsbad" },
  { Id: 42939, ChineseName: "夏洛特", Name: "Charlotte" },
  { Id: 43066, ChineseName: "丹佛", Name: "Denver" },
  { Id: 43108, ChineseName: "罗切斯特", Name: "Rochester" },
  { Id: 43119, ChineseName: "罗利", Name: "Rowley" },
  { Id: 43267, ChineseName: "斯托克顿", Name: "Stockton" },
  { Id: 43303, ChineseName: "锡拉丘兹", Name: "Syracuse" },
  { Id: 43345, ChineseName: "特伦顿", Name: "Trenton" },
  { Id: 43388, ChineseName: "维罗纳", Name: "Verona" },
  { Id: 43431, ChineseName: "沃特敦", Name: "Watertown" },
  { Id: 43499, ChineseName: "威尔明顿", Name: "Wilmington" },
  { Id: 43509, ChineseName: "温莎", Name: "Windsor" },
  { Id: 43613, ChineseName: "法明顿", Name: "Farmington" },
  { Id: 43616, ChineseName: "费耶特维尔", Name: "Fayetteville" },
  { Id: 43636, ChineseName: "佛罗伦萨", Name: "Florence(Colorado US)" },
  { Id: 43657, ChineseName: "法兰克福", Name: "Frankfort" },
  { Id: 43666, ChineseName: "弗里波特", Name: "Freeport" },
  { Id: 43746, ChineseName: "格林维尔", Name: "Greenville" },
  { Id: 43764, ChineseName: "汉密尔顿", Name: "Hamilton(Texas US)" },
  { Id: 43771, ChineseName: "汉考克", Name: "Hancock" },
  { Id: 43910, ChineseName: "卡尼", Name: "Kearney" },
  { Id: 43936, ChineseName: "拉巴斯", Name: "La Paz" },
  { Id: 43964, ChineseName: "拉斯维加斯", Name: "Las Vegas" },
  { Id: 43979, ChineseName: "利兹", Name: "Leeds" },
  { Id: 43988, ChineseName: "刘易斯堡", Name: "Lewisburg" },
  { Id: 44015, ChineseName: "朗维尤", Name: "Longview" },
  { Id: 44055, ChineseName: "曼海姆", Name: "Manheim" },
  { Id: 44064, ChineseName: "马里恩", Name: "Marion" },
  { Id: 44088, ChineseName: "默里迪恩", Name: "Meridian" },
  { Id: 44095, ChineseName: "米兰", Name: "Milan" },
  { Id: 44114, ChineseName: "门罗", Name: "Monroe" },
  { Id: 44123, ChineseName: "蒙特罗斯", Name: "Montrose" },
  { Id: 44174, ChineseName: "新伦敦", Name: "New London" },
  { Id: 44240, ChineseName: "奥尼尔", Name: "O'Neill" },
  { Id: 44256, ChineseName: "渥太华", Name: "Ottawa" },
  { Id: 44269, ChineseName: "帕迪尤卡", Name: "Paducah" },
  { Id: 44317, ChineseName: "匹兹堡", Name: "Pittsburg" },
  { Id: 44758, ChineseName: "拉特罗布", Name: "Latrobe" },
  { Id: 44759, ChineseName: "劳德代尔", Name: "Lauderdale" },
  { Id: 44997, ChineseName: "布兰顿", Name: "Brandon" },
  { Id: 45072, ChineseName: "德里", Name: "Delhi" },
  { Id: 45128, ChineseName: "大本德", Name: "Grand Bend" },
  { Id: 45131, ChineseName: "大福克斯", Name: "Grand Forks" },
  { Id: 45165, ChineseName: "休斯敦", Name: "Houston" },
  { Id: 45175, ChineseName: "杰克逊维尔", Name: "Jacksonville" },
  { Id: 45223, ChineseName: "利物浦", Name: "Liverpool" },
  { Id: 45296, ChineseName: "北本德", Name: "North Bend" },
  { Id: 45361, ChineseName: "普雷斯科特", Name: "Prescott" },
  { Id: 45396, ChineseName: "圣马丽斯", Name: "Saint Marys" },
  { Id: 45553, ChineseName: "惠灵顿", Name: "Wellington" },
  { Id: 45817, ChineseName: "约翰斯顿", Name: "Johnston" },
  { Id: 45847, ChineseName: "刘易斯顿", Name: "Lewiston" },
  { Id: 46833, ChineseName: "里昂", Name: "Laer" },
  { Id: 47543, ChineseName: "蓬塔德尔加达", Name: "Punta Delgada" },
  { Id: 48217, ChineseName: "蒙斯特", Name: "Munster" },
  { Id: 48613, ChineseName: "瓦拉德", Name: "Varades" },
  { Id: 49027, ChineseName: "科隆", Name: "Cologne" },
  { Id: 49357, ChineseName: "莫纳斯提尔", Name: "Monastir" },
  { Id: 51263, ChineseName: "阿特卡", Name: "Ateca" },
  { Id: 51286, ChineseName: "巴尔马塞达", Name: "Balmaseda" },
  { Id: 51355, ChineseName: "博洛尼亚", Name: "Bolonia" },
  { Id: 52285, ChineseName: "雷诺萨", Name: "Reinosa" },
  { Id: 52982, ChineseName: "达卡", Name: "Darica" },
  { Id: 53008, ChineseName: "加济帕夏", Name: "Gazipasa" },
  { Id: 53372, ChineseName: "阿格拉", Name: "Agra" },
  { Id: 55001, ChineseName: "罗克兰", Name: "Rokland" },
  { Id: 56137, ChineseName: "库塔伊西", Name: "Kutaisi" },
  { Id: 56424, ChineseName: "格罗兹尼", Name: "Groznyy" },
  { Id: 56428, ChineseName: "基洛夫", Name: "Kirov" },
  { Id: 56473, ChineseName: "利佩茨克", Name: "Lipetsk" },
  { Id: 56606, ChineseName: "伊热夫斯克", Name: "Izhevsk" },
  { Id: 56797, ChineseName: "尼斯", Name: "Nysa" },
  {
    Id: 56996,
    ChineseName: "诺维德沃马泽维斯科",
    Name: "Nowy Dwór Mazowiecki",
  },
  { Id: 58193, ChineseName: "圣萨尔瓦多", Name: "Sankt Salvator" },
  { Id: 58465, ChineseName: "霍利克罗斯", Name: "Holycross" },
  { Id: 58722, ChineseName: "圣皮埃尔", Name: "Saint-Pierre" },
  { Id: 58781, ChineseName: "查尔斯顿", Name: "Charleston" },
  { Id: 59394, ChineseName: "瓜达拉哈拉", Name: "Guadalajara" },
  { Id: 59436, ChineseName: "萨拉戈萨", Name: "Zaragoza" },
  { Id: 59454, ChineseName: "兰塞里亚", Name: "Lanseria" },
  { Id: 59489, ChineseName: "罗兹", Name: "Rhodes" },
  { Id: 59490, ChineseName: "里士满", Name: "Richmond" },
  { Id: 59590, ChineseName: "鲁比", Name: "Ruby" },
  { Id: 59623, ChineseName: "圣塞瓦斯蒂安", Name: "San Sebastian" },
  { Id: 59659, ChineseName: "圣克里斯托弗", Name: "Saint Christopher" },
  { Id: 59749, ChineseName: "桑坦德", Name: "Santander" },
  { Id: 60051, ChineseName: "昌迪格", Name: "Chandīgarh" },
  { Id: 60101, ChineseName: "坎普尔", Name: "KANPUR" },
  { Id: 60103, ChineseName: "卡瓦拉", Name: "Kārwār" },
  { Id: 60281, ChineseName: "巴罗", Name: "Paloh" },
  { Id: 60483, ChineseName: "拉雷多", Name: "Laredo" },
  { Id: 60545, ChineseName: "圣卢西亚", Name: "Santa Lucía" },
  { Id: 60694, ChineseName: "萨马拉", Name: "Sámara" },
  { Id: 60732, ChineseName: "圣路易斯", Name: "San Luis" },
  { Id: 61655, ChineseName: "索契", Name: "Sochi" },
  { Id: 61674, ChineseName: "叄祺", Name: "Tam Ky" },
  { Id: 61933, ChineseName: "沃洛涅日", Name: "Voronezh" },
  { Id: 62055, ChineseName: "奥古斯塔", Name: "Augusta" },
  { Id: 62207, ChineseName: "卑尔根", Name: "Bergen" },
  { Id: 62292, ChineseName: "圣安东尼奥", Name: "San Antonio" },
  { Id: 62319, ChineseName: "波德戈里察", Name: "Podgorica" },
  { Id: 62331, ChineseName: "赫尔辛堡", Name: "Helsingborg" },
  { Id: 62360, ChineseName: "伯灵顿", Name: "Burlington" },
  { Id: 62385, ChineseName: "莱昂", Name: "Leon" },
  { Id: 62407, ChineseName: "维多利亚", Name: "victoria" },
  { Id: 62410, ChineseName: "拉菲特", Name: "LaFayette" },
  { Id: 62511, ChineseName: "莱巴嫩", Name: "Lebanon" },
  { Id: 62512, ChineseName: "长滩", Name: "Long Beach" },
  { Id: 62513, ChineseName: "路易斯威尔", Name: "Louisville" },
  { Id: 62828, ChineseName: "阿伯丁", Name: "Aberdeen" },
  { Id: 62866, ChineseName: "曼彻斯特", Name: "Manchester" },
  { Id: 62888, ChineseName: "华盛顿", Name: "Washington" },
  { Id: 62924, ChineseName: "圣维森特", Name: "SAN VICENTE" },
  { Id: 62946, ChineseName: "兰格尔", Name: "LANGGUR" },
  { Id: 62953, ChineseName: "布尔萨", Name: "BOULSA" },
  { Id: 62956, ChineseName: "圣克拉拉", Name: "SANTA CLARA" },
  { Id: 62987, ChineseName: "马孔", Name: "Macon" },
  { Id: 63011, ChineseName: "达拉斯", Name: "Dalaas" },
  { Id: 63165, ChineseName: "卡萨布兰卡", Name: "Casa Branca" },
  { Id: 63897, ChineseName: "阿克拉", Name: "Acra" },
  { Id: 63939, ChineseName: "巴林", Name: "Baring" },
  { Id: 63960, ChineseName: "伯尔尼", Name: "Berne" },
  { Id: 64188, ChineseName: "热那亚", Name: "Genoa" },
  { Id: 64203, ChineseName: "格林纳达", Name: "Glenwood" },
  { Id: 64306, ChineseName: "卡拉马", Name: "Kalama" },
  { Id: 64469, ChineseName: "纳什维尔", Name: "Nashville" },
  { Id: 64848, ChineseName: "科斯", Name: "Cos" },
  { Id: 64912, ChineseName: "法戈", Name: "Fago" },
  { Id: 65116, ChineseName: "索尔兹伯里", Name: "Salisbury" },
  { Id: 65210, ChineseName: "金斯敦", Name: "Kingston South East" },
  { Id: 65223, ChineseName: "富兰克林", Name: "Franklin" },
  { Id: 65268, ChineseName: "埃克塞特", Name: "Exeter" },
  { Id: 66230, ChineseName: "苏黎世", Name: "Zurich" },
  { Id: 66280, ChineseName: "圣乔治", Name: "Saint George" },
  { Id: 66348, ChineseName: "南安普敦", Name: "Southampton" },
  { Id: 66411, ChineseName: "克拉克斯堡", Name: "Clarksburg" },
  { Id: 66438, ChineseName: "汉普顿", Name: "Hampton" },
  { Id: 66439, ChineseName: "汉诺威", Name: "Hanover" },
  { Id: 66452, ChineseName: "格拉夫顿", Name: "Grafton" },
  { Id: 66460, ChineseName: "弗朗西斯堡", Name: "Fort Frances" },
  { Id: 66486, ChineseName: "布里斯托尔", Name: "Bristol" },
  { Id: 66503, ChineseName: "贝茨维尔", Name: "Beamsville" },
  { Id: 66510, ChineseName: "奥斯汀", Name: "Austin" },
  { Id: 66616, ChineseName: "库奇", Name: "Quechee" },
  { Id: 66622, ChineseName: "雷恩", Name: "Rayne" },
  { Id: 66688, ChineseName: "塞伦", Name: "Siren" },
  { Id: 66727, ChineseName: "斯图加特", Name: "Stuttgart" },
  { Id: 66794, ChineseName: "沃索", Name: "Warsaw" },
  { Id: 66860, ChineseName: "白山", Name: "Hakusan" },
  { Id: 67087, ChineseName: "海斯", Name: "Hythe" },
  { Id: 67379, ChineseName: "什切青", Name: "Szczecin" },
  { Id: 68187, ChineseName: "波尔多", Name: "Portol" },
  { Id: 68205, ChineseName: "波城", Name: "Pau" },
  { Id: 68302, ChineseName: "林肯", Name: "Lincoln" },
  { Id: 68334, ChineseName: "贝尔法斯特", Name: "Belfast" },
  { Id: 68364, ChineseName: "卡利", Name: "Cagli" },
  { Id: 68855, ChineseName: "剑桥", Name: "Cambridge" },
  { Id: 76517, ChineseName: "圣地亚哥", Name: "Santiago" },
  { Id: 77027, ChineseName: "圣何塞", Name: "Puerto San Jose" },
  { Id: 77924, ChineseName: "恩菲达", Name: "Enfidha" },
  { Id: 78707, ChineseName: "奥克兰", Name: "Oakland" },
  { Id: 79559, ChineseName: "开罗", Name: "cairo" },
  { Id: 79631, ChineseName: "哈里斯堡", Name: "Harrisburg" },
  { Id: 85091, ChineseName: "江布尔州", Name: "Taraz" },
  { Id: 85105, ChineseName: "阿克拉维克", Name: "Aklavik" },
  { Id: 85115, ChineseName: "阿雷格里港", Name: "Porto Alegre" },
  { Id: 85127, ChineseName: "阿纳希姆莱克", Name: "Anahim Lake" },
  { Id: 85147, ChineseName: "埃尔多拉多", Name: "Eldorado" },
  { Id: 85247, ChineseName: "奥兰", Name: "Oran" },
  { Id: 85283, ChineseName: "奥兹恩基", Name: "Ouzinkie" },
  { Id: 85503, ChineseName: "迪凯特", Name: "Decatur" },
  { Id: 85512, ChineseName: "迪灵", Name: "Deering" },
  { Id: 85659, ChineseName: "盖恩斯维尔", Name: "Sovetskaya Gavan" },
  { Id: 85688, ChineseName: "哥伦布", Name: "Columbus" },
  { Id: 85870, ChineseName: "加登城", Name: "Garden City" },
  { Id: 85877, ChineseName: "加拉帕戈斯", Name: "Baltra Island" },
  { Id: 85912, ChineseName: "杰克逊", Name: "Jackson" },
  { Id: 85972, ChineseName: "卡勒克", Name: "Karluk" },
  { Id: 86123, ChineseName: "科尔德福特", Name: "Coldfoot" },
  { Id: 86315, ChineseName: "莱昂斯港", Name: "Port Lions" },
  { Id: 86374, ChineseName: "雷德道格", Name: "Red Dog" },
  { Id: 86613, ChineseName: "马尼拉", Name: "Manila" },
  { Id: 86642, ChineseName: "马歇尔", Name: "Marshall" },
  { Id: 86664, ChineseName: "麦迪逊", Name: "Madison" },
  { Id: 86753, ChineseName: "蒙特雷", Name: "Monterrey" },
  { Id: 86813, ChineseName: "莫林", Name: "Murrin" },
  { Id: 86995, ChineseName: "帕尔马", Name: "Palma" },
  { Id: 87296, ChineseName: "圣费尔南多", Name: "San Fernando" },
  { Id: 87317, ChineseName: "圣克鲁斯", Name: "Puerto Santa Cruz" },
  { Id: 87541, ChineseName: "特伦顿", Name: "Trenton" },
  { Id: 88056, ChineseName: "詹姆斯敦", Name: "Jamestown" },
  { Id: 88062, ChineseName: "朱诺", Name: "Juneau" },
  { Id: 91494, ChineseName: "纳帕基亚克", Name: "Napakiak" },
  { Id: 92353, ChineseName: "圣罗莎", Name: "Santa Rosa" },
  { Id: 92399, ChineseName: "昆西", Name: "Quincy" },
];
export default cities;
